var items = {
  "block.minecraft.acacia_button": "Дугме од багрема",
  "block.minecraft.acacia_door": "Врата од багрема",
  "block.minecraft.acacia_fence": "Ограда од багрема",
  "block.minecraft.acacia_fence_gate": "Капија од багрема",
  "block.minecraft.acacia_hanging_sign": "Акацијин висећи знак",
  "block.minecraft.acacia_leaves": "Лишће акације",
  "block.minecraft.acacia_log": "Дрво багрема",
  "block.minecraft.acacia_planks": "Багремове даске",
  "block.minecraft.acacia_pressure_plate": "Потисна плоча багрема",
  "block.minecraft.acacia_sapling": "Младица багрема",
  "block.minecraft.acacia_shelf": "Багремова полица",
  "block.minecraft.acacia_sign": "Знак од акације",
  "block.minecraft.acacia_slab": "Плоча багрема",
  "block.minecraft.acacia_stairs": "Степенице багремовог дрвета",
  "block.minecraft.acacia_trapdoor": "Окно од багрема",
  "block.minecraft.acacia_wall_hanging_sign": "Акацијин зидни висећи знак",
  "block.minecraft.acacia_wall_sign": "Знак од акације за зид",
  "block.minecraft.acacia_wood": "Дрво багрема",
  "block.minecraft.activator_rail": "Пруга са активатором",
  "block.minecraft.air": "Ваздух",
  "block.minecraft.allium": "Лук",
  "block.minecraft.amethyst_block": "Блок аметиста",
  "block.minecraft.amethyst_cluster": "Хрпа аметиста",
  "block.minecraft.ancient_debris": "Древни остаци",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Плота од андезита",
  "block.minecraft.andesite_stairs": "Степенице од андезита",
  "block.minecraft.andesite_wall": "Зид од андезита",
  "block.minecraft.anvil": "Наковањ",
  "block.minecraft.attached_melon_stem": "Прикачена стабљика лубенице",
  "block.minecraft.attached_pumpkin_stem": "Прикачена стабљика бундеве",
  "block.minecraft.azalea": "Азалеја",
  "block.minecraft.azalea_leaves": "Лишће азалеје",
  "block.minecraft.azure_bluet": "Плава хустонија",
  "block.minecraft.bamboo": "Бамбус",
  "block.minecraft.bamboo_block": "Блок од бамбуса",
  "block.minecraft.bamboo_button": "Бамбусово дугме",
  "block.minecraft.bamboo_door": "Врата од бамбуса",
  "block.minecraft.bamboo_fence": "Бамбусова ограда",
  "block.minecraft.bamboo_fence_gate": "Бамбусова капија",
  "block.minecraft.bamboo_hanging_sign": "Бамбусов висећи знак",
  "block.minecraft.bamboo_mosaic": "Бамбус мозаик",
  "block.minecraft.bamboo_mosaic_slab": "Бамбусова мозаик плоча",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбусове мозаик степенице",
  "block.minecraft.bamboo_planks": "Бамбусове даске",
  "block.minecraft.bamboo_pressure_plate": "Бамбусова потисна плоча",
  "block.minecraft.bamboo_sapling": "Пупољак бамбуса",
  "block.minecraft.bamboo_shelf": "Бамбусова полица",
  "block.minecraft.bamboo_sign": "Бамбусов знак",
  "block.minecraft.bamboo_slab": "Бамбусова плоча",
  "block.minecraft.bamboo_stairs": "Бамбусове степенице",
  "block.minecraft.bamboo_trapdoor": "Бамбусово окно",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбусов зидни висећи знак",
  "block.minecraft.bamboo_wall_sign": "Бамбусов зидни знак",
  "block.minecraft.banner.base.black": "Потпуно црно поље",
  "block.minecraft.banner.base.blue": "Потпуно плаво поље",
  "block.minecraft.banner.base.brown": "Потпуно браон поље",
  "block.minecraft.banner.base.cyan": "Потпуно тиркизно поље",
  "block.minecraft.banner.base.gray": "Потпуно сиво поље",
  "block.minecraft.banner.base.green": "Потпуно зелено поље",
  "block.minecraft.banner.base.light_blue": "Потпуно светлоплаво поље",
  "block.minecraft.banner.base.light_gray": "Потпуно светлосиво поље",
  "block.minecraft.banner.base.lime": "Потпуно светлозелено поље",
  "block.minecraft.banner.base.magenta": "Потпуно магента поље",
  "block.minecraft.banner.base.orange": "Потпуно наранџасто поље",
  "block.minecraft.banner.base.pink": "Потпуно розе поље",
  "block.minecraft.banner.base.purple": "Потпуно љубичасто поље",
  "block.minecraft.banner.base.red": "Потпуно црвено поље",
  "block.minecraft.banner.base.white": "Потпуно бело поље",
  "block.minecraft.banner.base.yellow": "Потпуно жуто поље",
  "block.minecraft.banner.border.black": "Црни оквир",
  "block.minecraft.banner.border.blue": "Плави оквир",
  "block.minecraft.banner.border.brown": "Браон оквир",
  "block.minecraft.banner.border.cyan": "Тиркизни оквир",
  "block.minecraft.banner.border.gray": "Сиви оквир",
  "block.minecraft.banner.border.green": "Зелени оквир",
  "block.minecraft.banner.border.light_blue": "Светлоплави оквир",
  "block.minecraft.banner.border.light_gray": "Светлосиви оквир",
  "block.minecraft.banner.border.lime": "Светлозелени оквир",
  "block.minecraft.banner.border.magenta": "Магента оквир",
  "block.minecraft.banner.border.orange": "Наранџасти оквир",
  "block.minecraft.banner.border.pink": "Розе оквир",
  "block.minecraft.banner.border.purple": "Љубичасти оквир",
  "block.minecraft.banner.border.red": "Црвени оквир",
  "block.minecraft.banner.border.white": "Бели оквир",
  "block.minecraft.banner.border.yellow": "Жути оквир",
  "block.minecraft.banner.bricks.black": "Црне цигле",
  "block.minecraft.banner.bricks.blue": "Плаве цигле",
  "block.minecraft.banner.bricks.brown": "Браон цигле",
  "block.minecraft.banner.bricks.cyan": "Тиркизна цигла",
  "block.minecraft.banner.bricks.gray": "Сиве цигле",
  "block.minecraft.banner.bricks.green": "Зелене цигле",
  "block.minecraft.banner.bricks.light_blue": "Светлоплаве цигле",
  "block.minecraft.banner.bricks.light_gray": "Светлосиве цигле",
  "block.minecraft.banner.bricks.lime": "Светлозелене цигле",
  "block.minecraft.banner.bricks.magenta": "Магента цигле",
  "block.minecraft.banner.bricks.orange": "Наранџасте цигле",
  "block.minecraft.banner.bricks.pink": "Розе цигле",
  "block.minecraft.banner.bricks.purple": "Љубичасте цигле",
  "block.minecraft.banner.bricks.red": "Црвене цигле",
  "block.minecraft.banner.bricks.white": "Беле цигле",
  "block.minecraft.banner.bricks.yellow": "Жуте цигле",
  "block.minecraft.banner.circle.black": "Црни кружић",
  "block.minecraft.banner.circle.blue": "Плави кружић",
  "block.minecraft.banner.circle.brown": "Браон кружић",
  "block.minecraft.banner.circle.cyan": "Тиркизни кружић",
  "block.minecraft.banner.circle.gray": "Сиви кружић",
  "block.minecraft.banner.circle.green": "Зелени кружић",
  "block.minecraft.banner.circle.light_blue": "Светлоплави кружић",
  "block.minecraft.banner.circle.light_gray": "Светлосиви кружић",
  "block.minecraft.banner.circle.lime": "Светлозелени кружић",
  "block.minecraft.banner.circle.magenta": "Магента кружић",
  "block.minecraft.banner.circle.orange": "Наранџасти кружић",
  "block.minecraft.banner.circle.pink": "Розе кружић",
  "block.minecraft.banner.circle.purple": "Љубичасти кружић",
  "block.minecraft.banner.circle.red": "Црвени кружић",
  "block.minecraft.banner.circle.white": "Бели кружић",
  "block.minecraft.banner.circle.yellow": "Жути кружић",
  "block.minecraft.banner.creeper.black": "Црни крипер",
  "block.minecraft.banner.creeper.blue": "Плави крипер",
  "block.minecraft.banner.creeper.brown": "Браон крипер",
  "block.minecraft.banner.creeper.cyan": "Тиркизни крипер",
  "block.minecraft.banner.creeper.gray": "Сиви крипер",
  "block.minecraft.banner.creeper.green": "Зелени крипер",
  "block.minecraft.banner.creeper.light_blue": "Светлоплави крипер",
  "block.minecraft.banner.creeper.light_gray": "Светлосиви крипер",
  "block.minecraft.banner.creeper.lime": "Светлозелени крипер",
  "block.minecraft.banner.creeper.magenta": "Магента крипер",
  "block.minecraft.banner.creeper.orange": "Наранџасти крипер",
  "block.minecraft.banner.creeper.pink": "Розе крипер",
  "block.minecraft.banner.creeper.purple": "Љубичасти крипер",
  "block.minecraft.banner.creeper.red": "Црвени крипер",
  "block.minecraft.banner.creeper.white": "Бели крипер",
  "block.minecraft.banner.creeper.yellow": "Жути крипер",
  "block.minecraft.banner.cross.black": "Црни Андријин крст",
  "block.minecraft.banner.cross.blue": "Плави Андријин крст",
  "block.minecraft.banner.cross.brown": "Браон Андријин крст",
  "block.minecraft.banner.cross.cyan": "Тиркизни Андријин крст",
  "block.minecraft.banner.cross.gray": "Сиви Андријин крст",
  "block.minecraft.banner.cross.green": "Зелени Андријин крст",
  "block.minecraft.banner.cross.light_blue": "Светлоплави Андријин крст",
  "block.minecraft.banner.cross.light_gray": "Светлосиви Андријин крст",
  "block.minecraft.banner.cross.lime": "Светлозелени Андријин крст",
  "block.minecraft.banner.cross.magenta": "Магента Андријин крст",
  "block.minecraft.banner.cross.orange": "Наранџасти Андријин крст",
  "block.minecraft.banner.cross.pink": "Розе Андријин крст",
  "block.minecraft.banner.cross.purple": "Љубичасти Андријин крст",
  "block.minecraft.banner.cross.red": "Црвени Андријин крст",
  "block.minecraft.banner.cross.white": "Бели Андријин крст",
  "block.minecraft.banner.cross.yellow": "Жути Андријин крст",
  "block.minecraft.banner.curly_border.black": "Црни увучени оквир",
  "block.minecraft.banner.curly_border.blue": "Плави увучени оквир",
  "block.minecraft.banner.curly_border.brown": "Браон увучени оквир",
  "block.minecraft.banner.curly_border.cyan": "Тиркизни увучени оквир",
  "block.minecraft.banner.curly_border.gray": "Сиви увучени оквир",
  "block.minecraft.banner.curly_border.green": "Зелени увучени оквир",
  "block.minecraft.banner.curly_border.light_blue": "Светлоплави увучени оквир",
  "block.minecraft.banner.curly_border.light_gray": "Светлосиви увучени оквир",
  "block.minecraft.banner.curly_border.lime": "Светлозелени увучени оквир",
  "block.minecraft.banner.curly_border.magenta": "Магента увучени оквир",
  "block.minecraft.banner.curly_border.orange": "Наранџасти увучени оквир",
  "block.minecraft.banner.curly_border.pink": "Розе увучени оквир",
  "block.minecraft.banner.curly_border.purple": "Љубичасти увучени оквир",
  "block.minecraft.banner.curly_border.red": "Црвени увучени оквир",
  "block.minecraft.banner.curly_border.white": "Бели увучени оквир",
  "block.minecraft.banner.curly_border.yellow": "Жути увучени оквир",
  "block.minecraft.banner.diagonal_left.black": "Црна лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.blue": "Плава лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.brown": "Браон лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.cyan": "Тиркизна лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.gray": "Сива лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.green": "Зелена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.light_blue": "Светлоплава лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.light_gray": "Светлосива лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.lime": "Светлозелена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.magenta": "Магента лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.orange": "Наранџаста лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.pink": "Розе лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.purple": "Љубичаста лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.red": "Црвена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.white": "Бела лева пуна дијагонала",
  "block.minecraft.banner.diagonal_left.yellow": "Жута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_right.black": "Црна десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.blue": "Плава десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.brown": "Браон десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.cyan": "Тиркизна десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.gray": "Сива десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.green": "Зелена десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.light_blue": "Светлоплава десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.light_gray": "Светлосива десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.lime": "Светлозелена десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.magenta": "Магента десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.orange": "Наранџаста десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.pink": "Роза десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.purple": "Љубичаста десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.red": "Црвена десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.white": "Бела десна пуна дијагонала",
  "block.minecraft.banner.diagonal_right.yellow": "Жута десна пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.black": "Црна лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.blue": "Плава лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.brown": "Браон лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.cyan": "Тиркизна горње лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.gray": "Сива лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.green": "Зелена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Светлоплава лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Светлосива лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.lime": "Светлозелена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.magenta": "Магента лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.orange": "Наранџаста лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.pink": "Розе лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.purple": "Љубичаста лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.red": "Црвена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.white": "Бела лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.black": "Црна лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.blue": "Плава лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.brown": "Браон лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.cyan": "Тиркизна горње десна пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.gray": "Сива обрнута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.green": "Зелена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Светлоплава лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Светлосива лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.lime": "Светлозелена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.magenta": "Магента обрнута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.orange": "Наранџаста обрнута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.pink": "Розе обрнута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.purple": "Љубичаста лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.red": "Црвена лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.white": "Бела обрнута лева пуна дијагонала",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жута обрнута лева пуна дијагонала",
  "block.minecraft.banner.flow.black": "Црни ток",
  "block.minecraft.banner.flow.blue": "Плави ток",
  "block.minecraft.banner.flow.brown": "Браон ток",
  "block.minecraft.banner.flow.cyan": "Тиркизни ток",
  "block.minecraft.banner.flow.gray": "Сиви ток",
  "block.minecraft.banner.flow.green": "Зелени ток",
  "block.minecraft.banner.flow.light_blue": "Светлоплави ток",
  "block.minecraft.banner.flow.light_gray": "Светлосиви ток",
  "block.minecraft.banner.flow.lime": "Светлозелени ток",
  "block.minecraft.banner.flow.magenta": "Магента ток",
  "block.minecraft.banner.flow.orange": "Наранџасти ток",
  "block.minecraft.banner.flow.pink": "Розе ток",
  "block.minecraft.banner.flow.purple": "Љубичасти ток",
  "block.minecraft.banner.flow.red": "Црвени ток",
  "block.minecraft.banner.flow.white": "Бели ток",
  "block.minecraft.banner.flow.yellow": "Жути ток",
  "block.minecraft.banner.flower.black": "Црни цвет",
  "block.minecraft.banner.flower.blue": "Плави цвет",
  "block.minecraft.banner.flower.brown": "Браон цвет",
  "block.minecraft.banner.flower.cyan": "Тиркизни цвет",
  "block.minecraft.banner.flower.gray": "Сиви цвет",
  "block.minecraft.banner.flower.green": "Зелени цвет",
  "block.minecraft.banner.flower.light_blue": "Светлоплави цвет",
  "block.minecraft.banner.flower.light_gray": "Светлосиви цвет",
  "block.minecraft.banner.flower.lime": "Светлозелени цвет",
  "block.minecraft.banner.flower.magenta": "Магента цвет",
  "block.minecraft.banner.flower.orange": "Наранџасти цвет",
  "block.minecraft.banner.flower.pink": "Розе цвет",
  "block.minecraft.banner.flower.purple": "Љубичасти цвет",
  "block.minecraft.banner.flower.red": "Црвени цвет",
  "block.minecraft.banner.flower.white": "Бели цвет",
  "block.minecraft.banner.flower.yellow": "Жути цвет",
  "block.minecraft.banner.globe.black": "Црни глобус",
  "block.minecraft.banner.globe.blue": "Плави глобус",
  "block.minecraft.banner.globe.brown": "Браон глобус",
  "block.minecraft.banner.globe.cyan": "Тиркизни глобус",
  "block.minecraft.banner.globe.gray": "Сиви глобус",
  "block.minecraft.banner.globe.green": "Зелени глобус",
  "block.minecraft.banner.globe.light_blue": "Светлоплави глобус",
  "block.minecraft.banner.globe.light_gray": "Светлосиви глобус",
  "block.minecraft.banner.globe.lime": "Светлозелени глобус",
  "block.minecraft.banner.globe.magenta": "Магента глобус",
  "block.minecraft.banner.globe.orange": "Наранџасти глобус",
  "block.minecraft.banner.globe.pink": "Розе глобус",
  "block.minecraft.banner.globe.purple": "Љубичасти глобус",
  "block.minecraft.banner.globe.red": "Црвени глобус",
  "block.minecraft.banner.globe.white": "Бели глобус",
  "block.minecraft.banner.globe.yellow": "Жути глобус",
  "block.minecraft.banner.gradient.black": "Црни градијент",
  "block.minecraft.banner.gradient.blue": "Плави градијент",
  "block.minecraft.banner.gradient.brown": "Браон градијент",
  "block.minecraft.banner.gradient.cyan": "Тиркизни градијент",
  "block.minecraft.banner.gradient.gray": "Сиви градијент",
  "block.minecraft.banner.gradient.green": "Зелени градијент",
  "block.minecraft.banner.gradient.light_blue": "Светлоплави градијент",
  "block.minecraft.banner.gradient.light_gray": "Светлосиви градијент",
  "block.minecraft.banner.gradient.lime": "Светлозелени градијент",
  "block.minecraft.banner.gradient.magenta": "Магента градијент",
  "block.minecraft.banner.gradient.orange": "Наранџасти градијент",
  "block.minecraft.banner.gradient.pink": "Розе градијент",
  "block.minecraft.banner.gradient.purple": "Љубичасти градијент",
  "block.minecraft.banner.gradient.red": "Црвени градијент",
  "block.minecraft.banner.gradient.white": "Бели градијент",
  "block.minecraft.banner.gradient.yellow": "Жути градијент",
  "block.minecraft.banner.gradient_up.black": "Црни градијент нагоре",
  "block.minecraft.banner.gradient_up.blue": "Плави градијент нагоре",
  "block.minecraft.banner.gradient_up.brown": "Браон градијент нагоре",
  "block.minecraft.banner.gradient_up.cyan": "Тиркизни градијент нагоре",
  "block.minecraft.banner.gradient_up.gray": "Сиви градијент нагоре",
  "block.minecraft.banner.gradient_up.green": "Зелени градијент нагоре",
  "block.minecraft.banner.gradient_up.light_blue": "Светлоплави градијент нагоре",
  "block.minecraft.banner.gradient_up.light_gray": "Светлосиви градијент нагоре",
  "block.minecraft.banner.gradient_up.lime": "Светлозелени градијент нагоре",
  "block.minecraft.banner.gradient_up.magenta": "Магента градијент нагоре",
  "block.minecraft.banner.gradient_up.orange": "Наранџасти градијент нагоре",
  "block.minecraft.banner.gradient_up.pink": "Розе градијент нагоре",
  "block.minecraft.banner.gradient_up.purple": "Љубичасти градијент нагоре",
  "block.minecraft.banner.gradient_up.red": "Црвени градијент нагоре",
  "block.minecraft.banner.gradient_up.white": "Бели градијент нагоре",
  "block.minecraft.banner.gradient_up.yellow": "Жути градијент нагоре",
  "block.minecraft.banner.guster.black": "Црни циклон",
  "block.minecraft.banner.guster.blue": "Плави циклон",
  "block.minecraft.banner.guster.brown": "Браон циклон",
  "block.minecraft.banner.guster.cyan": "Тиркизни циклон",
  "block.minecraft.banner.guster.gray": "Сиви циклон",
  "block.minecraft.banner.guster.green": "Зелени циклон",
  "block.minecraft.banner.guster.light_blue": "Светлоплави циклон",
  "block.minecraft.banner.guster.light_gray": "Светлосиви циклон",
  "block.minecraft.banner.guster.lime": "Светлозелени циклон",
  "block.minecraft.banner.guster.magenta": "Магента циклон",
  "block.minecraft.banner.guster.orange": "Наранџасти циклон",
  "block.minecraft.banner.guster.pink": "Розе циклон",
  "block.minecraft.banner.guster.purple": "Љубичасти циклон",
  "block.minecraft.banner.guster.red": "Црвени циклон",
  "block.minecraft.banner.guster.white": "Бели циклон",
  "block.minecraft.banner.guster.yellow": "Жути циклон",
  "block.minecraft.banner.half_horizontal.black": "Црна горња половина",
  "block.minecraft.banner.half_horizontal.blue": "Плава гоња половина",
  "block.minecraft.banner.half_horizontal.brown": "Браон горња половина",
  "block.minecraft.banner.half_horizontal.cyan": "Тиркизна горња половина",
  "block.minecraft.banner.half_horizontal.gray": "Сива горња половина",
  "block.minecraft.banner.half_horizontal.green": "Зелена горња половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Светлоплава горња половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Светлосива горња половина",
  "block.minecraft.banner.half_horizontal.lime": "Светлозелена горња половина",
  "block.minecraft.banner.half_horizontal.magenta": "Магента горња половина",
  "block.minecraft.banner.half_horizontal.orange": "Наранџаста горња половина",
  "block.minecraft.banner.half_horizontal.pink": "Розе горња половина",
  "block.minecraft.banner.half_horizontal.purple": "Љубичаста горња половина",
  "block.minecraft.banner.half_horizontal.red": "Црвена горња половина",
  "block.minecraft.banner.half_horizontal.white": "Бела горња половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жута горња половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Црна доња половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Плава доња половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Браон доња половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Тиркизна доња половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сива доња половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелена доња половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Светлоплава доња половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Светлосива доња половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Светлозелена доња половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Магента доња половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Наранџаста доња половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Розе доња половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Љубичаста доња половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Црвена доња половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Бела доња половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жута доња половина",
  "block.minecraft.banner.half_vertical.black": "Црна лева половина",
  "block.minecraft.banner.half_vertical.blue": "Плава лева половина",
  "block.minecraft.banner.half_vertical.brown": "Браон лева половина",
  "block.minecraft.banner.half_vertical.cyan": "Тиркизна лева половина",
  "block.minecraft.banner.half_vertical.gray": "Сива лева половина",
  "block.minecraft.banner.half_vertical.green": "Зелена лева половина",
  "block.minecraft.banner.half_vertical.light_blue": "Светлоплава лева половина",
  "block.minecraft.banner.half_vertical.light_gray": "Светлосива лева половина",
  "block.minecraft.banner.half_vertical.lime": "Светлозелена лева половина",
  "block.minecraft.banner.half_vertical.magenta": "Магента лева половина",
  "block.minecraft.banner.half_vertical.orange": "Наранџаста лева половина",
  "block.minecraft.banner.half_vertical.pink": "Розе лева половина",
  "block.minecraft.banner.half_vertical.purple": "Љубичаста лева половина",
  "block.minecraft.banner.half_vertical.red": "Црвена лева половина",
  "block.minecraft.banner.half_vertical.white": "Бела лева половина",
  "block.minecraft.banner.half_vertical.yellow": "Жута лева половина",
  "block.minecraft.banner.half_vertical_right.black": "Црна десна половина",
  "block.minecraft.banner.half_vertical_right.blue": "Плава десна половина",
  "block.minecraft.banner.half_vertical_right.brown": "Браон десна половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Тиркизна десна половина",
  "block.minecraft.banner.half_vertical_right.gray": "Сива десна половина",
  "block.minecraft.banner.half_vertical_right.green": "Зелена десна половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Светлоплава десна половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Светлосива десна половина",
  "block.minecraft.banner.half_vertical_right.lime": "Светлозелена десна половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Магента десна половина",
  "block.minecraft.banner.half_vertical_right.orange": "Наранџаста десна половина",
  "block.minecraft.banner.half_vertical_right.pink": "Розе десна половина",
  "block.minecraft.banner.half_vertical_right.purple": "Љубичаста десна половина",
  "block.minecraft.banner.half_vertical_right.red": "Црвена десна половина",
  "block.minecraft.banner.half_vertical_right.white": "Бела десна половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жута десна половина",
  "block.minecraft.banner.mojang.black": "Црна ствар",
  "block.minecraft.banner.mojang.blue": "Плава ствар",
  "block.minecraft.banner.mojang.brown": "Браон ствар",
  "block.minecraft.banner.mojang.cyan": "Тиркизна ствар",
  "block.minecraft.banner.mojang.gray": "Сива ствар",
  "block.minecraft.banner.mojang.green": "Зелена ствар",
  "block.minecraft.banner.mojang.light_blue": "Светлоплава ствар",
  "block.minecraft.banner.mojang.light_gray": "Светлосива ствар",
  "block.minecraft.banner.mojang.lime": "Светлозелена ствар",
  "block.minecraft.banner.mojang.magenta": "Магента ствар",
  "block.minecraft.banner.mojang.orange": "Наранджаста ствар",
  "block.minecraft.banner.mojang.pink": "Розе ствар",
  "block.minecraft.banner.mojang.purple": "Љубичаста ствар",
  "block.minecraft.banner.mojang.red": "Црвена ствар",
  "block.minecraft.banner.mojang.white": "Бела ствар",
  "block.minecraft.banner.mojang.yellow": "Жута ствар",
  "block.minecraft.banner.piglin.black": "Црна њушка",
  "block.minecraft.banner.piglin.blue": "Плава њушка",
  "block.minecraft.banner.piglin.brown": "Браон њушка",
  "block.minecraft.banner.piglin.cyan": "Тиркизна њушка",
  "block.minecraft.banner.piglin.gray": "Сива њушка",
  "block.minecraft.banner.piglin.green": "Зелена њушка",
  "block.minecraft.banner.piglin.light_blue": "Светлоплава њушка",
  "block.minecraft.banner.piglin.light_gray": "Светлосива њушка",
  "block.minecraft.banner.piglin.lime": "Светлозелена њушка",
  "block.minecraft.banner.piglin.magenta": "Магента њушка",
  "block.minecraft.banner.piglin.orange": "Наранџаста њушка",
  "block.minecraft.banner.piglin.pink": "Розе њушка",
  "block.minecraft.banner.piglin.purple": "Љубичаста њушка",
  "block.minecraft.banner.piglin.red": "Црвена њушка",
  "block.minecraft.banner.piglin.white": "Бела њушка",
  "block.minecraft.banner.piglin.yellow": "Жута њушка",
  "block.minecraft.banner.rhombus.black": "Црни ромб",
  "block.minecraft.banner.rhombus.blue": "Плави ромб",
  "block.minecraft.banner.rhombus.brown": "Браон ромб",
  "block.minecraft.banner.rhombus.cyan": "Тиркизни ромб",
  "block.minecraft.banner.rhombus.gray": "Сиви ромб",
  "block.minecraft.banner.rhombus.green": "Зелени ромб",
  "block.minecraft.banner.rhombus.light_blue": "Светлоплави ромб",
  "block.minecraft.banner.rhombus.light_gray": "Светлосиви ромб",
  "block.minecraft.banner.rhombus.lime": "Светлозелени ромб",
  "block.minecraft.banner.rhombus.magenta": "Магента ромб",
  "block.minecraft.banner.rhombus.orange": "Наранџасти ромб",
  "block.minecraft.banner.rhombus.pink": "Розе ромб",
  "block.minecraft.banner.rhombus.purple": "Љубичасти ромб",
  "block.minecraft.banner.rhombus.red": "Црвени ромб",
  "block.minecraft.banner.rhombus.white": "Бели ромб",
  "block.minecraft.banner.rhombus.yellow": "Жути ромб",
  "block.minecraft.banner.skull.black": "Црна лобања",
  "block.minecraft.banner.skull.blue": "Плава лобања",
  "block.minecraft.banner.skull.brown": "Браон лобања",
  "block.minecraft.banner.skull.cyan": "Тиркизна лобања",
  "block.minecraft.banner.skull.gray": "Сива лобања",
  "block.minecraft.banner.skull.green": "Зелена лобања",
  "block.minecraft.banner.skull.light_blue": "Светлоплава лобања",
  "block.minecraft.banner.skull.light_gray": "Светлосива лобања",
  "block.minecraft.banner.skull.lime": "Светлозелена лобања",
  "block.minecraft.banner.skull.magenta": "Магента лобања",
  "block.minecraft.banner.skull.orange": "Наранџаста лобања",
  "block.minecraft.banner.skull.pink": "Розе лобања",
  "block.minecraft.banner.skull.purple": "Љубичаста лобања",
  "block.minecraft.banner.skull.red": "Црвена лобања",
  "block.minecraft.banner.skull.white": "Бела лобања",
  "block.minecraft.banner.skull.yellow": "Жута лобања",
  "block.minecraft.banner.small_stripes.black": "Црне решетке",
  "block.minecraft.banner.small_stripes.blue": "Плаве решетке",
  "block.minecraft.banner.small_stripes.brown": "Браон решетке",
  "block.minecraft.banner.small_stripes.cyan": "Тиркизне пруге",
  "block.minecraft.banner.small_stripes.gray": "Сиве решетке",
  "block.minecraft.banner.small_stripes.green": "Зелене решетке",
  "block.minecraft.banner.small_stripes.light_blue": "Светлоплаве решетке",
  "block.minecraft.banner.small_stripes.light_gray": "Светлосиве решетке",
  "block.minecraft.banner.small_stripes.lime": "Светлозелене решетке",
  "block.minecraft.banner.small_stripes.magenta": "Магента решетке",
  "block.minecraft.banner.small_stripes.orange": "Наранџасте пруге",
  "block.minecraft.banner.small_stripes.pink": "Розе решетке",
  "block.minecraft.banner.small_stripes.purple": "Љубичасте решетке",
  "block.minecraft.banner.small_stripes.red": "Црвене решетке",
  "block.minecraft.banner.small_stripes.white": "Беле пруге",
  "block.minecraft.banner.small_stripes.yellow": "Жуте решетке",
  "block.minecraft.banner.square_bottom_left.black": "Црни квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.blue": "Плави квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.brown": "Браон квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.cyan": "Тиркизни квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.gray": "Сиви квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.green": "Зелени квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.light_blue": "Светлоплави квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.light_gray": "Светлосиви квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.lime": "Светлозелени квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.magenta": "Магента квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.orange": "Наранџасти квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.pink": "Пинк квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.purple": "Љубичасти квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.red": "Црвени квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.white": "Бели квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_left.yellow": "Жути квадрат у доњем левом углу",
  "block.minecraft.banner.square_bottom_right.black": "Црни квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.blue": "Плави квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.brown": "Браон квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.cyan": "Тиркизни квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.gray": "Сиви квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.green": "Зелени квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.light_blue": "Светлоплави квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.light_gray": "Светлосиви квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.lime": "Светлозелени квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.magenta": "Магента квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.orange": "Наранџасти квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.pink": "Пинк квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.purple": "Љубичасти квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.red": "Црвени квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.white": "Бели квадрат у доњем десном углу",
  "block.minecraft.banner.square_bottom_right.yellow": "Жути квадрат у доњем десном углу",
  "block.minecraft.banner.square_top_left.black": "Црни квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.blue": "Плави квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.brown": "Браон квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.cyan": "Тиркизни квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.gray": "Сиви квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.green": "Зелени квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.light_blue": "Светлоплави квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.light_gray": "Светлосиви квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.lime": "Светлозелени квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.magenta": "Магента квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.orange": "Наранџасти квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.pink": "Розе квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.purple": "Љубичасти квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.red": "Црвени квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.white": "Бели квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_left.yellow": "Жути квадрат у горњем левом углу",
  "block.minecraft.banner.square_top_right.black": "Црни квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.blue": "Плави квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.brown": "Браон квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.cyan": "Тиркизни квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.gray": "Сиви квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.green": "Зелени квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.light_blue": "Светлоплави квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.light_gray": "Светлосиви квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.lime": "Светлозелени квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.magenta": "Магента квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.orange": "Наранџасти квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.pink": "Розе квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.purple": "Љубичасти квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.red": "Црвени квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.white": "Бели квадрат у горњем десном углу",
  "block.minecraft.banner.square_top_right.yellow": "Жути квадрат у горњем десном углу",
  "block.minecraft.banner.straight_cross.black": "Црни крст",
  "block.minecraft.banner.straight_cross.blue": "Плави крст",
  "block.minecraft.banner.straight_cross.brown": "Браон крст",
  "block.minecraft.banner.straight_cross.cyan": "Тиркизни крст",
  "block.minecraft.banner.straight_cross.gray": "Сиви крст",
  "block.minecraft.banner.straight_cross.green": "Зелени крст",
  "block.minecraft.banner.straight_cross.light_blue": "Светлоплави крст",
  "block.minecraft.banner.straight_cross.light_gray": "Светлосиви крст",
  "block.minecraft.banner.straight_cross.lime": "Светлозелени крст",
  "block.minecraft.banner.straight_cross.magenta": "Магента крст",
  "block.minecraft.banner.straight_cross.orange": "Наранджасти крст",
  "block.minecraft.banner.straight_cross.pink": "Розе крст",
  "block.minecraft.banner.straight_cross.purple": "Љубичасти крст",
  "block.minecraft.banner.straight_cross.red": "Црвени крст",
  "block.minecraft.banner.straight_cross.white": "Бели крст",
  "block.minecraft.banner.straight_cross.yellow": "Жути крст",
  "block.minecraft.banner.stripe_bottom.black": "Црни доњи део",
  "block.minecraft.banner.stripe_bottom.blue": "Плави доњи део",
  "block.minecraft.banner.stripe_bottom.brown": "Браон доњи део",
  "block.minecraft.banner.stripe_bottom.cyan": "Тиркизни доњи део",
  "block.minecraft.banner.stripe_bottom.gray": "Сиви доњи део",
  "block.minecraft.banner.stripe_bottom.green": "Зелени доњи део",
  "block.minecraft.banner.stripe_bottom.light_blue": "Светлоплави доњи део",
  "block.minecraft.banner.stripe_bottom.light_gray": "Светлосиви доњи део",
  "block.minecraft.banner.stripe_bottom.lime": "Светлозелени доњи део",
  "block.minecraft.banner.stripe_bottom.magenta": "Магента доњи део",
  "block.minecraft.banner.stripe_bottom.orange": "Наранџасти доњи део",
  "block.minecraft.banner.stripe_bottom.pink": "Розе доњи део",
  "block.minecraft.banner.stripe_bottom.purple": "Љубичасти доњи део",
  "block.minecraft.banner.stripe_bottom.red": "Црвени доњи део",
  "block.minecraft.banner.stripe_bottom.white": "Бели доњи део",
  "block.minecraft.banner.stripe_bottom.yellow": "Жути доњи део",
  "block.minecraft.banner.stripe_center.black": "Црна трака",
  "block.minecraft.banner.stripe_center.blue": "Плава трака",
  "block.minecraft.banner.stripe_center.brown": "Браон трака",
  "block.minecraft.banner.stripe_center.cyan": "Тиркизна трака",
  "block.minecraft.banner.stripe_center.gray": "Сива трака",
  "block.minecraft.banner.stripe_center.green": "Зелена трака",
  "block.minecraft.banner.stripe_center.light_blue": "Светлоплава трака",
  "block.minecraft.banner.stripe_center.light_gray": "Светлосива трака",
  "block.minecraft.banner.stripe_center.lime": "Светлозелена трака",
  "block.minecraft.banner.stripe_center.magenta": "Магента трака",
  "block.minecraft.banner.stripe_center.orange": "Наранџаста трака",
  "block.minecraft.banner.stripe_center.pink": "Розе трака",
  "block.minecraft.banner.stripe_center.purple": "Љубичаста трака",
  "block.minecraft.banner.stripe_center.red": "Црвена трака",
  "block.minecraft.banner.stripe_center.white": "Бела трака",
  "block.minecraft.banner.stripe_center.yellow": "Жута трака",
  "block.minecraft.banner.stripe_downleft.black": "Црна лева дијагонала",
  "block.minecraft.banner.stripe_downleft.blue": "Плава лева дијагонала",
  "block.minecraft.banner.stripe_downleft.brown": "Браон лева дијагонала",
  "block.minecraft.banner.stripe_downleft.cyan": "Тиркизна лева дијагонала",
  "block.minecraft.banner.stripe_downleft.gray": "Сива лева дијагонала",
  "block.minecraft.banner.stripe_downleft.green": "Зелена лева дијагонала",
  "block.minecraft.banner.stripe_downleft.light_blue": "Светлоплава лева дијагонала",
  "block.minecraft.banner.stripe_downleft.light_gray": "Светлосива лева дијагонала",
  "block.minecraft.banner.stripe_downleft.lime": "Светлозелена лева дијагонала",
  "block.minecraft.banner.stripe_downleft.magenta": "Магента лева дијагонала",
  "block.minecraft.banner.stripe_downleft.orange": "Наранџаста лева дијагонала",
  "block.minecraft.banner.stripe_downleft.pink": "Розе лева дијагонала",
  "block.minecraft.banner.stripe_downleft.purple": "Љубичаста лева дијагонала",
  "block.minecraft.banner.stripe_downleft.red": "Црвена лева дијагонала",
  "block.minecraft.banner.stripe_downleft.white": "Бела лева дијагонала",
  "block.minecraft.banner.stripe_downleft.yellow": "Жута лева дијагонала",
  "block.minecraft.banner.stripe_downright.black": "Црна десна дијагонала",
  "block.minecraft.banner.stripe_downright.blue": "Плава десна дијагонала",
  "block.minecraft.banner.stripe_downright.brown": "Браон десна дијагонала",
  "block.minecraft.banner.stripe_downright.cyan": "Тиркизна десна дијагонала",
  "block.minecraft.banner.stripe_downright.gray": "Сива десна дијагонала",
  "block.minecraft.banner.stripe_downright.green": "Зелена десна дијагонала",
  "block.minecraft.banner.stripe_downright.light_blue": "Светлоплава десна дијагонала",
  "block.minecraft.banner.stripe_downright.light_gray": "Светлосива десна дијагонала",
  "block.minecraft.banner.stripe_downright.lime": "Светлозелена десна дијагонала",
  "block.minecraft.banner.stripe_downright.magenta": "Магента десна дијагонала",
  "block.minecraft.banner.stripe_downright.orange": "Наранџаста десна дијагонала",
  "block.minecraft.banner.stripe_downright.pink": "Розе десна дијагонала",
  "block.minecraft.banner.stripe_downright.purple": "Љубичаста десна дијагонала",
  "block.minecraft.banner.stripe_downright.red": "Црвена десна дијагонала",
  "block.minecraft.banner.stripe_downright.white": "Бела десна дијагонала",
  "block.minecraft.banner.stripe_downright.yellow": "Жута десна дијагонала",
  "block.minecraft.banner.stripe_left.black": "Црни леви стуб",
  "block.minecraft.banner.stripe_left.blue": "Плави леви стуб",
  "block.minecraft.banner.stripe_left.brown": "Браон леви стуб",
  "block.minecraft.banner.stripe_left.cyan": "Тиркизни леви стуб",
  "block.minecraft.banner.stripe_left.gray": "Сиви леви стуб",
  "block.minecraft.banner.stripe_left.green": "Зелени леви стуб",
  "block.minecraft.banner.stripe_left.light_blue": "Светлоплави леви стуб",
  "block.minecraft.banner.stripe_left.light_gray": "Светлосиви леви стуб",
  "block.minecraft.banner.stripe_left.lime": "Светлозелени леви стуб",
  "block.minecraft.banner.stripe_left.magenta": "Магента леви стуб",
  "block.minecraft.banner.stripe_left.orange": "Наранџасти леви стуб",
  "block.minecraft.banner.stripe_left.pink": "Розе леви стуб",
  "block.minecraft.banner.stripe_left.purple": "Љубичасти леви стуб",
  "block.minecraft.banner.stripe_left.red": "Црвени леви стуб",
  "block.minecraft.banner.stripe_left.white": "Бели леви стуб",
  "block.minecraft.banner.stripe_left.yellow": "Жути леви стуб",
  "block.minecraft.banner.stripe_middle.black": "Црна средња пруга",
  "block.minecraft.banner.stripe_middle.blue": "Плава средња пруга",
  "block.minecraft.banner.stripe_middle.brown": "Браон средња пруга",
  "block.minecraft.banner.stripe_middle.cyan": "Тиркизна средња пруга",
  "block.minecraft.banner.stripe_middle.gray": "Сива средња пруга",
  "block.minecraft.banner.stripe_middle.green": "Зелена средња пруга",
  "block.minecraft.banner.stripe_middle.light_blue": "Светлоплава средња пруга",
  "block.minecraft.banner.stripe_middle.light_gray": "Светлосива средња пруга",
  "block.minecraft.banner.stripe_middle.lime": "Светлозелена средња пруга",
  "block.minecraft.banner.stripe_middle.magenta": "Магента средња пруга",
  "block.minecraft.banner.stripe_middle.orange": "Наранџаста средња пруга",
  "block.minecraft.banner.stripe_middle.pink": "Пинк средња пруга",
  "block.minecraft.banner.stripe_middle.purple": "Љубичаста средња пруга",
  "block.minecraft.banner.stripe_middle.red": "Црвена средња пруга",
  "block.minecraft.banner.stripe_middle.white": "Бела средња пруга",
  "block.minecraft.banner.stripe_middle.yellow": "Жута средња пруга",
  "block.minecraft.banner.stripe_right.black": "Црни десни стуб",
  "block.minecraft.banner.stripe_right.blue": "Плави десни стуб",
  "block.minecraft.banner.stripe_right.brown": "Браон десни стуб",
  "block.minecraft.banner.stripe_right.cyan": "Тиркизни десни стуб",
  "block.minecraft.banner.stripe_right.gray": "Сиви десни стуб",
  "block.minecraft.banner.stripe_right.green": "Зелени десни стуб",
  "block.minecraft.banner.stripe_right.light_blue": "Светлоплави десни стуб",
  "block.minecraft.banner.stripe_right.light_gray": "Светлосиви десни стуб",
  "block.minecraft.banner.stripe_right.lime": "Светлозелени десни стуб",
  "block.minecraft.banner.stripe_right.magenta": "Магента десни стуб",
  "block.minecraft.banner.stripe_right.orange": "Наранџасти десни стуб",
  "block.minecraft.banner.stripe_right.pink": "Пинк десни стуб",
  "block.minecraft.banner.stripe_right.purple": "Љубичасти десни стуб",
  "block.minecraft.banner.stripe_right.red": "Црвени десни стуб",
  "block.minecraft.banner.stripe_right.white": "Бели десни стуб",
  "block.minecraft.banner.stripe_right.yellow": "Жути десни стуб",
  "block.minecraft.banner.stripe_top.black": "Црн горњи део",
  "block.minecraft.banner.stripe_top.blue": "Плави горњи део",
  "block.minecraft.banner.stripe_top.brown": "Браон горњи део",
  "block.minecraft.banner.stripe_top.cyan": "Тиркизни горњи део",
  "block.minecraft.banner.stripe_top.gray": "Сиви горњи део",
  "block.minecraft.banner.stripe_top.green": "Зелен горњи део",
  "block.minecraft.banner.stripe_top.light_blue": "Светлоплави горњи део",
  "block.minecraft.banner.stripe_top.light_gray": "Светлосив горњи део",
  "block.minecraft.banner.stripe_top.lime": "Светлозелени горњи део",
  "block.minecraft.banner.stripe_top.magenta": "Магента горњи део",
  "block.minecraft.banner.stripe_top.orange": "Наранџасти горњи део",
  "block.minecraft.banner.stripe_top.pink": "Розе горњи део",
  "block.minecraft.banner.stripe_top.purple": "Љубичасти горњи део",
  "block.minecraft.banner.stripe_top.red": "Црвен горњи део",
  "block.minecraft.banner.stripe_top.white": "Бели горњи део",
  "block.minecraft.banner.stripe_top.yellow": "Жути горњи део",
  "block.minecraft.banner.triangle_bottom.black": "Црна пирамида",
  "block.minecraft.banner.triangle_bottom.blue": "Плава пирамида",
  "block.minecraft.banner.triangle_bottom.brown": "Браон пирамида",
  "block.minecraft.banner.triangle_bottom.cyan": "Тиркизна пирамида",
  "block.minecraft.banner.triangle_bottom.gray": "Сива пирамида",
  "block.minecraft.banner.triangle_bottom.green": "Зелена пирамида",
  "block.minecraft.banner.triangle_bottom.light_blue": "Светлоплава пирамида",
  "block.minecraft.banner.triangle_bottom.light_gray": "Светлосива пирамида",
  "block.minecraft.banner.triangle_bottom.lime": "Светлозелена пирамида",
  "block.minecraft.banner.triangle_bottom.magenta": "Магента пирамида",
  "block.minecraft.banner.triangle_bottom.orange": "Наранџаста пирамида",
  "block.minecraft.banner.triangle_bottom.pink": "Розе пирамида",
  "block.minecraft.banner.triangle_bottom.purple": "Љубичаста пирамида",
  "block.minecraft.banner.triangle_bottom.red": "Црвена пирамида",
  "block.minecraft.banner.triangle_bottom.white": "Бела пирамида",
  "block.minecraft.banner.triangle_bottom.yellow": "Жута пирамида",
  "block.minecraft.banner.triangle_top.black": "Црна обрнута пирамида",
  "block.minecraft.banner.triangle_top.blue": "Плава обрнута пирамида",
  "block.minecraft.banner.triangle_top.brown": "Браон обрнута пирамида",
  "block.minecraft.banner.triangle_top.cyan": "Обрнута тиркизна пирамида",
  "block.minecraft.banner.triangle_top.gray": "Сива обрнута пирамида",
  "block.minecraft.banner.triangle_top.green": "Зелена обрнута пирамида",
  "block.minecraft.banner.triangle_top.light_blue": "Светлоплава обрнута пирамида",
  "block.minecraft.banner.triangle_top.light_gray": "Светлосива обрнута пирамида",
  "block.minecraft.banner.triangle_top.lime": "Светлозелена обрнута пирамида",
  "block.minecraft.banner.triangle_top.magenta": "Магента обрнута пирамида",
  "block.minecraft.banner.triangle_top.orange": "Наранџаста обрнута пирамида",
  "block.minecraft.banner.triangle_top.pink": "Розе обрнута пирамида",
  "block.minecraft.banner.triangle_top.purple": "Љубичаста обрнута пирамида",
  "block.minecraft.banner.triangle_top.red": "Црвена обрнута пирамида",
  "block.minecraft.banner.triangle_top.white": "Бела обрнута пирамида",
  "block.minecraft.banner.triangle_top.yellow": "Жута пирамида",
  "block.minecraft.banner.triangles_bottom.black": "Црни доњи зуби",
  "block.minecraft.banner.triangles_bottom.blue": "Плави доњи зуби",
  "block.minecraft.banner.triangles_bottom.brown": "Браон доњи зуби",
  "block.minecraft.banner.triangles_bottom.cyan": "Тиркизни доњи зуби",
  "block.minecraft.banner.triangles_bottom.gray": "Сиви доњи зуби",
  "block.minecraft.banner.triangles_bottom.green": "Зелени доњи зуби",
  "block.minecraft.banner.triangles_bottom.light_blue": "Светлоплави доњи зуби",
  "block.minecraft.banner.triangles_bottom.light_gray": "Светлосиви доњи зуби",
  "block.minecraft.banner.triangles_bottom.lime": "Светлозелени доњи зуби",
  "block.minecraft.banner.triangles_bottom.magenta": "Магента доњи зуби",
  "block.minecraft.banner.triangles_bottom.orange": "Наранџасти доњи зуби",
  "block.minecraft.banner.triangles_bottom.pink": "Розе доњи зуби",
  "block.minecraft.banner.triangles_bottom.purple": "Љубичасти доњи зуби",
  "block.minecraft.banner.triangles_bottom.red": "Црвени доњи зуби",
  "block.minecraft.banner.triangles_bottom.white": "Бели доњи зуби",
  "block.minecraft.banner.triangles_bottom.yellow": "Жути доњи зуби",
  "block.minecraft.banner.triangles_top.black": "Црни горњи зуби",
  "block.minecraft.banner.triangles_top.blue": "Плави горњи зуби",
  "block.minecraft.banner.triangles_top.brown": "Браон горњи зуби",
  "block.minecraft.banner.triangles_top.cyan": "Тиркизни горњи зуби",
  "block.minecraft.banner.triangles_top.gray": "Сиви горњи зуби",
  "block.minecraft.banner.triangles_top.green": "Зелени горњи зуби",
  "block.minecraft.banner.triangles_top.light_blue": "Светлоплави горњи зуби",
  "block.minecraft.banner.triangles_top.light_gray": "Светлосиви горњи зуби",
  "block.minecraft.banner.triangles_top.lime": "Светлозелени горњи зуби",
  "block.minecraft.banner.triangles_top.magenta": "Магента горњи зуби",
  "block.minecraft.banner.triangles_top.orange": "Наранџасти горњи зуби",
  "block.minecraft.banner.triangles_top.pink": "Розе горњи зуби",
  "block.minecraft.banner.triangles_top.purple": "Љубичасти горњи зуби",
  "block.minecraft.banner.triangles_top.red": "Црвени горњи зуби",
  "block.minecraft.banner.triangles_top.white": "Бели горњи зуби",
  "block.minecraft.banner.triangles_top.yellow": "Жути горњи зуби",
  "block.minecraft.barrel": "Буре",
  "block.minecraft.barrier": "Препрека",
  "block.minecraft.basalt": "Базалт",
  "block.minecraft.beacon": "Светионик",
  "block.minecraft.beacon.primary": "Примарни ефекат",
  "block.minecraft.beacon.secondary": "Секундарни ефекат",
  "block.minecraft.bed.no_sleep": "Можете спавати само ноћу или током грмљавина",
  "block.minecraft.bed.not_safe": "Сада не можеш да се одмараш; чудовишта су у близини",
  "block.minecraft.bed.obstructed": "Овај кревет је блокиран",
  "block.minecraft.bed.occupied": "Овај кревет је заузет",
  "block.minecraft.bed.too_far_away": "Сада не можеш да се одмараш; кревет је предалеко",
  "block.minecraft.bedrock": "Темељац",
  "block.minecraft.bee_nest": "Пчелино гнездо",
  "block.minecraft.beehive": "Кошница",
  "block.minecraft.beetroots": "Цвекла",
  "block.minecraft.bell": "Звоно",
  "block.minecraft.big_dripleaf": "Велики кап-лист",
  "block.minecraft.big_dripleaf_stem": "Велика стабљика кап-листа",
  "block.minecraft.birch_button": "Брезово дугме",
  "block.minecraft.birch_door": "Брезова врата",
  "block.minecraft.birch_fence": "Брезова ограда",
  "block.minecraft.birch_fence_gate": "Брезова капија",
  "block.minecraft.birch_hanging_sign": "Брезов висећи знак",
  "block.minecraft.birch_leaves": "Брезово лишће",
  "block.minecraft.birch_log": "Брезов пањ",
  "block.minecraft.birch_planks": "Брезове даске",
  "block.minecraft.birch_pressure_plate": "Брезова потисна плоча",
  "block.minecraft.birch_sapling": "Брезова младица",
  "block.minecraft.birch_shelf": "Брезова полица",
  "block.minecraft.birch_sign": "Брезов знак",
  "block.minecraft.birch_slab": "Брезова плоча",
  "block.minecraft.birch_stairs": "Брезове степенице",
  "block.minecraft.birch_trapdoor": "Брезово окно",
  "block.minecraft.birch_wall_hanging_sign": "Брезов зидни висећи знак",
  "block.minecraft.birch_wall_sign": "Брезов зидни знак",
  "block.minecraft.birch_wood": "Брезовина",
  "block.minecraft.black_banner": "Црна застава",
  "block.minecraft.black_bed": "Црн кревет",
  "block.minecraft.black_candle": "Црна свећа",
  "block.minecraft.black_candle_cake": "Торта са црном свећом",
  "block.minecraft.black_carpet": "Црни тепих",
  "block.minecraft.black_concrete": "Црни бетон",
  "block.minecraft.black_concrete_powder": "Црни бетон у праху",
  "block.minecraft.black_glazed_terracotta": "Теракота са глазуром црне",
  "block.minecraft.black_shulker_box": "Црна Шулкер кутија",
  "block.minecraft.black_stained_glass": "Црно обојено стакло",
  "block.minecraft.black_stained_glass_pane": "Црна стаклена плоча",
  "block.minecraft.black_terracotta": "Црна теракота",
  "block.minecraft.black_wool": "Црна вуна",
  "block.minecraft.blackstone": "Црна калдрма",
  "block.minecraft.blackstone_slab": "Плоча од црне калдрме",
  "block.minecraft.blackstone_stairs": "Степенице од црне калдрме",
  "block.minecraft.blackstone_wall": "Зид од црне калдрме",
  "block.minecraft.blast_furnace": "Висока пећница",
  "block.minecraft.blue_banner": "Плава застава",
  "block.minecraft.blue_bed": "Плав кревет",
  "block.minecraft.blue_candle": "Плава свећа",
  "block.minecraft.blue_candle_cake": "Торта са плавом свећом",
  "block.minecraft.blue_carpet": "Плави тепих",
  "block.minecraft.blue_concrete": "Плави бетон",
  "block.minecraft.blue_concrete_powder": "Плави бетон у праху",
  "block.minecraft.blue_glazed_terracotta": "Теракота са глазуром плаве",
  "block.minecraft.blue_ice": "Плави лед",
  "block.minecraft.blue_orchid": "Плава oрхидеја",
  "block.minecraft.blue_shulker_box": "Тамно плава Шулкер кутија",
  "block.minecraft.blue_stained_glass": "Плаво обојено стакло",
  "block.minecraft.blue_stained_glass_pane": "Плава стаклена плоча",
  "block.minecraft.blue_terracotta": "Плава теракота",
  "block.minecraft.blue_wool": "Плава вуна",
  "block.minecraft.bone_block": "Блок од костију",
  "block.minecraft.bookshelf": "Полица за књиге",
  "block.minecraft.brain_coral": "Наборани корал",
  "block.minecraft.brain_coral_block": "Блок набораног корала",
  "block.minecraft.brain_coral_fan": "Наборана корална лепеза",
  "block.minecraft.brain_coral_wall_fan": "Наборана корална зидна лепеза",
  "block.minecraft.brewing_stand": "Самовар за напитке",
  "block.minecraft.brick_slab": "Циглена плоча",
  "block.minecraft.brick_stairs": "Циглене степенице",
  "block.minecraft.brick_wall": "Циглени зид",
  "block.minecraft.bricks": "Цигле",
  "block.minecraft.brown_banner": "Браон застава",
  "block.minecraft.brown_bed": "Браон кревет",
  "block.minecraft.brown_candle": "Браон свећа",
  "block.minecraft.brown_candle_cake": "Торта са браон свећом",
  "block.minecraft.brown_carpet": "Браон тепих",
  "block.minecraft.brown_concrete": "Браон бетон",
  "block.minecraft.brown_concrete_powder": "Браон бетон у праху",
  "block.minecraft.brown_glazed_terracotta": "Теракота са глазуром браон",
  "block.minecraft.brown_mushroom": "Браон печурка",
  "block.minecraft.brown_mushroom_block": "Блок браон печурке",
  "block.minecraft.brown_shulker_box": "Браон Шулкер кутија",
  "block.minecraft.brown_stained_glass": "Враон обојено стакло",
  "block.minecraft.brown_stained_glass_pane": "Браон стаклена плоча",
  "block.minecraft.brown_terracotta": "Браон теракота",
  "block.minecraft.brown_wool": "Браон вуна",
  "block.minecraft.bubble_column": "Колона мехура",
  "block.minecraft.bubble_coral": "Мехурасти корал",
  "block.minecraft.bubble_coral_block": "Блок мехурастог корала",
  "block.minecraft.bubble_coral_fan": "Мехураста корална лепеза",
  "block.minecraft.bubble_coral_wall_fan": "Мехураста корална зидна лепеза",
  "block.minecraft.budding_amethyst": "Растући аметист",
  "block.minecraft.bush": "Жбун",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактусов цвет",
  "block.minecraft.cake": "Торта",
  "block.minecraft.calcite": "Калцит",
  "block.minecraft.calibrated_sculk_sensor": "Калибрисани скалк сензор",
  "block.minecraft.campfire": "Логорска ватра",
  "block.minecraft.candle": "Свећа",
  "block.minecraft.candle_cake": "Торта са свећом",
  "block.minecraft.carrots": "Шаргарепе",
  "block.minecraft.cartography_table": "Сто за картографију",
  "block.minecraft.carved_pumpkin": "Урезана бундева",
  "block.minecraft.cauldron": "Котао",
  "block.minecraft.cave_air": "Пећински ваздух",
  "block.minecraft.cave_vines": "Пећинске лијане",
  "block.minecraft.cave_vines_plant": "Биљка пећинске лијане",
  "block.minecraft.chain": "Ланац",
  "block.minecraft.chain_command_block": "Везни командни блок",
  "block.minecraft.cherry_button": "Трешњино дугме",
  "block.minecraft.cherry_door": "Трешњина врата",
  "block.minecraft.cherry_fence": "Трешњина ограда",
  "block.minecraft.cherry_fence_gate": "Трешњина капија",
  "block.minecraft.cherry_hanging_sign": "Трешњин висећи знак",
  "block.minecraft.cherry_leaves": "Трешњино лишће",
  "block.minecraft.cherry_log": "Трешњино дрво",
  "block.minecraft.cherry_planks": "Трешњине даске",
  "block.minecraft.cherry_pressure_plate": "Трешњина потисна плоча",
  "block.minecraft.cherry_sapling": "Трешњина младица",
  "block.minecraft.cherry_shelf": "Трешњина полица",
  "block.minecraft.cherry_sign": "Трешњин знак",
  "block.minecraft.cherry_slab": "Трешњина плоча",
  "block.minecraft.cherry_stairs": "Трешњине степенице",
  "block.minecraft.cherry_trapdoor": "Трешњино окно",
  "block.minecraft.cherry_wall_hanging_sign": "Трешњин зидни висећи знак",
  "block.minecraft.cherry_wall_sign": "Трешњин зидни знак",
  "block.minecraft.cherry_wood": "Трешњино дрво",
  "block.minecraft.chest": "Ковчег",
  "block.minecraft.chipped_anvil": "Окрњен наковањ",
  "block.minecraft.chiseled_bookshelf": "Исклесана полица за књиге",
  "block.minecraft.chiseled_copper": "Исклесани бакар",
  "block.minecraft.chiseled_deepslate": "Исклесан шкриљац",
  "block.minecraft.chiseled_nether_bricks": "Исклесане Недер цигле",
  "block.minecraft.chiseled_polished_blackstone": "Исклесана углачана црна калдрма",
  "block.minecraft.chiseled_quartz_block": "Исклесани кварц",
  "block.minecraft.chiseled_red_sandstone": "Исклесани црвени пешчар",
  "block.minecraft.chiseled_resin_bricks": "Исклесане цигле смоле",
  "block.minecraft.chiseled_sandstone": "Исклесани пешчар",
  "block.minecraft.chiseled_stone_bricks": "Исклесане камене цигле",
  "block.minecraft.chiseled_tuff": "Исклесани туф",
  "block.minecraft.chiseled_tuff_bricks": "Туфф цигле",
  "block.minecraft.chorus_flower": "Хорус цвет",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Затворен окоцвет",
  "block.minecraft.coal_block": "Блок угља",
  "block.minecraft.coal_ore": "Руда угља",
  "block.minecraft.coarse_dirt": "Храпава земља",
  "block.minecraft.cobbled_deepslate": "Калдрмисан шкриљац",
  "block.minecraft.cobbled_deepslate_slab": "Плоча калдрмисаног шкриљца",
  "block.minecraft.cobbled_deepslate_stairs": "Степенице калдрмисаног шкриљца",
  "block.minecraft.cobbled_deepslate_wall": "Зид од калдрмисаног шкриљца",
  "block.minecraft.cobblestone": "Калдрма",
  "block.minecraft.cobblestone_slab": "Плоча од калдрме",
  "block.minecraft.cobblestone_stairs": "Степенице од калдрме",
  "block.minecraft.cobblestone_wall": "Зид од калдрме",
  "block.minecraft.cobweb": "Паучина",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Командни блок",
  "block.minecraft.comparator": "Редстоун компаратор",
  "block.minecraft.composter": "Компостер",
  "block.minecraft.conduit": "Цевовод",
  "block.minecraft.copper_bars": "Бакарне решетке",
  "block.minecraft.copper_block": "Блок бакра",
  "block.minecraft.copper_bulb": "Бакарна сијалица",
  "block.minecraft.copper_chain": "Бакарни ланац",
  "block.minecraft.copper_chest": "Бакарни ковчег",
  "block.minecraft.copper_door": "Бакарна врата",
  "block.minecraft.copper_golem_statue": "Кип бакарног голема",
  "block.minecraft.copper_grate": "Бакарне ренде",
  "block.minecraft.copper_lantern": "Бакарни Фењер",
  "block.minecraft.copper_ore": "Руда бакра",
  "block.minecraft.copper_torch": "Бакарна бакља",
  "block.minecraft.copper_trapdoor": "Бакарно окно",
  "block.minecraft.copper_wall_torch": "Бакарна зидна бакља",
  "block.minecraft.cornflower": "Различак",
  "block.minecraft.cracked_deepslate_bricks": "Напукле шкриљасте цигле",
  "block.minecraft.cracked_deepslate_tiles": "Напукле шкриљасте плочице",
  "block.minecraft.cracked_nether_bricks": "Напукле Недер цигле",
  "block.minecraft.cracked_polished_blackstone_bricks": "Напукле углачане цигле од црне калдрме",
  "block.minecraft.cracked_stone_bricks": "Напукле камене цигле",
  "block.minecraft.crafter": "Произвођач",
  "block.minecraft.crafting_table": "Занатски сто",
  "block.minecraft.creaking_heart": "Шкрипаво срце",
  "block.minecraft.creeper_head": "Криперова глава",
  "block.minecraft.creeper_wall_head": "Зидна Криперова глава",
  "block.minecraft.crimson_button": "Гримизно дугме",
  "block.minecraft.crimson_door": "Гримизна врата",
  "block.minecraft.crimson_fence": "Гримизна ограда",
  "block.minecraft.crimson_fence_gate": "Гримизна капија",
  "block.minecraft.crimson_fungus": "Гримизна гљива",
  "block.minecraft.crimson_hanging_sign": "Гримизни висећи знак",
  "block.minecraft.crimson_hyphae": "Гримизна хифа",
  "block.minecraft.crimson_nylium": "Гримизни нилијум",
  "block.minecraft.crimson_planks": "Гримизне даске",
  "block.minecraft.crimson_pressure_plate": "Гримизна потисна плоча",
  "block.minecraft.crimson_roots": "Гримизно корење",
  "block.minecraft.crimson_shelf": "Гримизна полица",
  "block.minecraft.crimson_sign": "Гримизни знак",
  "block.minecraft.crimson_slab": "Гримизна плоча",
  "block.minecraft.crimson_stairs": "Гримизне степенице",
  "block.minecraft.crimson_stem": "Гримизна стабљика",
  "block.minecraft.crimson_trapdoor": "Гримизно окно",
  "block.minecraft.crimson_wall_hanging_sign": "Гримизни висећи зидни знак",
  "block.minecraft.crimson_wall_sign": "Гримизни зидни знак",
  "block.minecraft.crying_obsidian": "Плачући обсидијан",
  "block.minecraft.cut_copper": "Сечени бакар",
  "block.minecraft.cut_copper_slab": "Плоча сеченог бакра",
  "block.minecraft.cut_copper_stairs": "Сечене степенице од бакра",
  "block.minecraft.cut_red_sandstone": "Сечени црвени пешчар",
  "block.minecraft.cut_red_sandstone_slab": "Плоча црвеног сеченог пешчара",
  "block.minecraft.cut_sandstone": "Сечени пешчар",
  "block.minecraft.cut_sandstone_slab": "Плоча сеченог пешчара",
  "block.minecraft.cyan_banner": "Тиркизна застава",
  "block.minecraft.cyan_bed": "Тиркизни кревет",
  "block.minecraft.cyan_candle": "Тиркизна свећа",
  "block.minecraft.cyan_candle_cake": "Торта са тиркизном свећом",
  "block.minecraft.cyan_carpet": "Тиркизни тепих",
  "block.minecraft.cyan_concrete": "Тиркизни бетон",
  "block.minecraft.cyan_concrete_powder": "Цијан бетон у праху",
  "block.minecraft.cyan_glazed_terracotta": "Теракота са цијан глазуром",
  "block.minecraft.cyan_shulker_box": "Тиркизна Шулкер кутија",
  "block.minecraft.cyan_stained_glass": "Тиркизно обојено стакло",
  "block.minecraft.cyan_stained_glass_pane": "Тиркизна стаклена плоча",
  "block.minecraft.cyan_terracotta": "Тиркизна теракота",
  "block.minecraft.cyan_wool": "Тиркизна вуна",
  "block.minecraft.damaged_anvil": "Oштећен наковањ",
  "block.minecraft.dandelion": "Маслачак",
  "block.minecraft.dark_oak_button": "Тамно храстово дугме",
  "block.minecraft.dark_oak_door": "Тамна храстова врата",
  "block.minecraft.dark_oak_fence": "Тамна храстова ограда",
  "block.minecraft.dark_oak_fence_gate": "Тамна храстова капија",
  "block.minecraft.dark_oak_hanging_sign": "Тамни храстов висећи знак",
  "block.minecraft.dark_oak_leaves": "Тамно храстово лишће",
  "block.minecraft.dark_oak_log": "Тамни храстов пањ",
  "block.minecraft.dark_oak_planks": "Тамне храстове даске",
  "block.minecraft.dark_oak_pressure_plate": "Тамно храстова потисна плоча",
  "block.minecraft.dark_oak_sapling": "Младица тамног храста",
  "block.minecraft.dark_oak_shelf": "Тамна храстова полица",
  "block.minecraft.dark_oak_sign": "Тамни храстов знак",
  "block.minecraft.dark_oak_slab": "Тамна храстова плоча",
  "block.minecraft.dark_oak_stairs": "Тамне храстове степенице",
  "block.minecraft.dark_oak_trapdoor": "Тамно храстово окно",
  "block.minecraft.dark_oak_wall_hanging_sign": "Мрачни храстов зидни висећи знак",
  "block.minecraft.dark_oak_wall_sign": "Тамни храстов зидни знак",
  "block.minecraft.dark_oak_wood": "Тамна храстовина",
  "block.minecraft.dark_prismarine": "Тамни призмарин",
  "block.minecraft.dark_prismarine_slab": "Тамна плоча призмарина",
  "block.minecraft.dark_prismarine_stairs": "Тамне степенице призмарина",
  "block.minecraft.daylight_detector": "Сензор за сунчеву светлост",
  "block.minecraft.dead_brain_coral": "Мртви Наборани корал",
  "block.minecraft.dead_brain_coral_block": "Блок мртвог набораног корала",
  "block.minecraft.dead_brain_coral_fan": "Мртва наборана корална лепеза",
  "block.minecraft.dead_brain_coral_wall_fan": "Мртва наборана корална зидна лепеза",
  "block.minecraft.dead_bubble_coral": "Мртви мехурасти Корал",
  "block.minecraft.dead_bubble_coral_block": "Блок мртвог мехурастог корала",
  "block.minecraft.dead_bubble_coral_fan": "Мртва мехураста корална лепеза",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мртва мехураста корална зидна лепеза",
  "block.minecraft.dead_bush": "Увенули жбун",
  "block.minecraft.dead_fire_coral": "Мртви Ватрени Корал",
  "block.minecraft.dead_fire_coral_block": "Блок мртвог ватреног корала",
  "block.minecraft.dead_fire_coral_fan": "Мртва ватрена корална лепеза",
  "block.minecraft.dead_fire_coral_wall_fan": "Мртва ватрена корална зидна лепеза",
  "block.minecraft.dead_horn_coral": "Мртви Рогасти Корал",
  "block.minecraft.dead_horn_coral_block": "Блок мртвог рогастог корала",
  "block.minecraft.dead_horn_coral_fan": "Мртва рогаста корална лепеза",
  "block.minecraft.dead_horn_coral_wall_fan": "Мртва рогаста корална зидна лепеза",
  "block.minecraft.dead_tube_coral": "Мртви цевасти корал",
  "block.minecraft.dead_tube_coral_block": "Блок мртвог цевастог корала",
  "block.minecraft.dead_tube_coral_fan": "Мртва цеваста корална лепеза",
  "block.minecraft.dead_tube_coral_wall_fan": "Мртва цеваста корална зидна лепеза",
  "block.minecraft.decorated_pot": "Украшени ћуп",
  "block.minecraft.deepslate": "Шкриљац",
  "block.minecraft.deepslate_brick_slab": "Плоча од шкриљастих цигли",
  "block.minecraft.deepslate_brick_stairs": "Степенице од шкриљастих цигли",
  "block.minecraft.deepslate_brick_wall": "Зид од шкриљастих цигли",
  "block.minecraft.deepslate_bricks": "Шкриљасте цигле",
  "block.minecraft.deepslate_coal_ore": "Шкриљаста руда угља",
  "block.minecraft.deepslate_copper_ore": "Шкриљаста руда бакра",
  "block.minecraft.deepslate_diamond_ore": "Шкриљаста руда дијаманта",
  "block.minecraft.deepslate_emerald_ore": "Шкриљаста руда смарагда",
  "block.minecraft.deepslate_gold_ore": "Шкриљаста руда злата",
  "block.minecraft.deepslate_iron_ore": "Шкриљаста руда гвожђа",
  "block.minecraft.deepslate_lapis_ore": "Шкриљаста руда лапис лазулија",
  "block.minecraft.deepslate_redstone_ore": "Шкриљаста редстоун руда",
  "block.minecraft.deepslate_tile_slab": "Плоча од шкриљастих плочица",
  "block.minecraft.deepslate_tile_stairs": "Степенице од шкриљастих плочица",
  "block.minecraft.deepslate_tile_wall": "Зид од шкриљастих плочица",
  "block.minecraft.deepslate_tiles": "Шкриљасте плочице",
  "block.minecraft.detector_rail": "Пруга са сензором",
  "block.minecraft.diamond_block": "Дијамантски блок",
  "block.minecraft.diamond_ore": "Руда дијаманта",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Плоча од диорита",
  "block.minecraft.diorite_stairs": "Степенице од диорита",
  "block.minecraft.diorite_wall": "Зид од диорита",
  "block.minecraft.dirt": "Земља",
  "block.minecraft.dirt_path": "Земљани пут",
  "block.minecraft.dispenser": "Испаљивач",
  "block.minecraft.dragon_egg": "Змајево јаје",
  "block.minecraft.dragon_head": "Змајева глава",
  "block.minecraft.dragon_wall_head": "Зидна Змајева глава",
  "block.minecraft.dried_ghast": "Осушени гаст",
  "block.minecraft.dried_kelp_block": "Осушени блок морских алги",
  "block.minecraft.dripstone_block": "Блок капмена",
  "block.minecraft.dropper": "Избацивач",
  "block.minecraft.emerald_block": "Блок смарагда",
  "block.minecraft.emerald_ore": "Руда смарагда",
  "block.minecraft.enchanting_table": "Сто за чарање",
  "block.minecraft.end_gateway": "Енд капија",
  "block.minecraft.end_portal": "Енд портал",
  "block.minecraft.end_portal_frame": "Рам од Енд портала",
  "block.minecraft.end_rod": "Енд штап",
  "block.minecraft.end_stone": "Енд камен",
  "block.minecraft.end_stone_brick_slab": "Плоча од камених Енд цигли",
  "block.minecraft.end_stone_brick_stairs": "Степенице од камених Енд цигли",
  "block.minecraft.end_stone_brick_wall": "Зид од камених Енд цигли",
  "block.minecraft.end_stone_bricks": "Енд камене цигле",
  "block.minecraft.ender_chest": "Ендер ковчег",
  "block.minecraft.exposed_chiseled_copper": "Изложени клесан бакар",
  "block.minecraft.exposed_copper": "Изложени бакар",
  "block.minecraft.exposed_copper_bars": "Изложене бакарне решетке",
  "block.minecraft.exposed_copper_bulb": "Изложена бакарна сијалица",
  "block.minecraft.exposed_copper_chain": "Изложени бакарни ланац",
  "block.minecraft.exposed_copper_chest": "Изложени бакарни ковчег",
  "block.minecraft.exposed_copper_door": "Изложена бакарна врата",
  "block.minecraft.exposed_copper_golem_statue": "Изложени кип бакарног голема",
  "block.minecraft.exposed_copper_grate": "Изложена бакарна капија",
  "block.minecraft.exposed_copper_lantern": "Изложени бакарни фењер",
  "block.minecraft.exposed_copper_trapdoor": "Изложена бакарна трапдоор",
  "block.minecraft.exposed_cut_copper": "Изложени сечени бакар",
  "block.minecraft.exposed_cut_copper_slab": "Изложена плоча од сеченог бакра",
  "block.minecraft.exposed_cut_copper_stairs": "Изложене степенице од сеченог бакра",
  "block.minecraft.exposed_lightning_rod": "Изложени громобран",
  "block.minecraft.farmland": "Ораница",
  "block.minecraft.fern": "Папрат",
  "block.minecraft.fire": "Ватра",
  "block.minecraft.fire_coral": "Ватрени корал",
  "block.minecraft.fire_coral_block": "Ватрени корални блок",
  "block.minecraft.fire_coral_fan": "Ватрена корална лепеза",
  "block.minecraft.fire_coral_wall_fan": "Ватрена корална зидна лепеза",
  "block.minecraft.firefly_bush": "Жбун свитаца",
  "block.minecraft.fletching_table": "Стрељашки сто",
  "block.minecraft.flower_pot": "Саксија",
  "block.minecraft.flowering_azalea": "Цветајућа азалеја",
  "block.minecraft.flowering_azalea_leaves": "Лишће цветајуће азалеје",
  "block.minecraft.frogspawn": "Жабљи мрест",
  "block.minecraft.frosted_ice": "Смрзнути лед",
  "block.minecraft.furnace": "Пећница",
  "block.minecraft.gilded_blackstone": "Позлаћена црна калдрма",
  "block.minecraft.glass": "Стакло",
  "block.minecraft.glass_pane": "Стаклена плоча",
  "block.minecraft.glow_lichen": "Светлећи лишајеви",
  "block.minecraft.glowstone": "Жаркамен",
  "block.minecraft.gold_block": "Златни блок",
  "block.minecraft.gold_ore": "Руда злата",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Плоча од гранита",
  "block.minecraft.granite_stairs": "Степенице од гранита",
  "block.minecraft.granite_wall": "Зид од гранита",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Блок траве",
  "block.minecraft.gravel": "Шљунак",
  "block.minecraft.gray_banner": "Сива застава",
  "block.minecraft.gray_bed": "Сив кревет",
  "block.minecraft.gray_candle": "Сива свећа",
  "block.minecraft.gray_candle_cake": "Торта са сивом свећом",
  "block.minecraft.gray_carpet": "Сиви тепих",
  "block.minecraft.gray_concrete": "Сиви бетон",
  "block.minecraft.gray_concrete_powder": "Сиви бетон у праху",
  "block.minecraft.gray_glazed_terracotta": "Теракота са глазуром сиве",
  "block.minecraft.gray_shulker_box": "Сива Шулкер кутија",
  "block.minecraft.gray_stained_glass": "Сиво обојено стакло",
  "block.minecraft.gray_stained_glass_pane": "Сива стаклена плоча",
  "block.minecraft.gray_terracotta": "Сива теракота",
  "block.minecraft.gray_wool": "Сива вуна",
  "block.minecraft.green_banner": "Зелена застава",
  "block.minecraft.green_bed": "Зелен кревет",
  "block.minecraft.green_candle": "Зелена свећа",
  "block.minecraft.green_candle_cake": "Торта са зеленом свећом",
  "block.minecraft.green_carpet": "Зелени тепих",
  "block.minecraft.green_concrete": "Зелени бетон",
  "block.minecraft.green_concrete_powder": "Зелени бетон у праху",
  "block.minecraft.green_glazed_terracotta": "Теракота са глазуром зелене",
  "block.minecraft.green_shulker_box": "Зелена Шулкер кутија",
  "block.minecraft.green_stained_glass": "Зелено обојено стакло",
  "block.minecraft.green_stained_glass_pane": "Зелена стаклена плоча",
  "block.minecraft.green_terracotta": "Зелена теракота",
  "block.minecraft.green_wool": "Зелена вуна",
  "block.minecraft.grindstone": "Млински камен",
  "block.minecraft.hanging_roots": "Висеће корење",
  "block.minecraft.hay_block": "Бала сена",
  "block.minecraft.heavy_core": "Тешко језгро",
  "block.minecraft.heavy_weighted_pressure_plate": "Тешка потисна плоча",
  "block.minecraft.honey_block": "Блок меда",
  "block.minecraft.honeycomb_block": "Блок саћа",
  "block.minecraft.hopper": "Левак",
  "block.minecraft.horn_coral": "Рогасти корал",
  "block.minecraft.horn_coral_block": "Рогасти корални блок",
  "block.minecraft.horn_coral_fan": "Рогаста корална лепеза",
  "block.minecraft.horn_coral_wall_fan": "Рогаста корална зидна лепеза",
  "block.minecraft.ice": "Лед",
  "block.minecraft.infested_chiseled_stone_bricks": "Заражене исклесане камене цигле",
  "block.minecraft.infested_cobblestone": "Заражена калдрма",
  "block.minecraft.infested_cracked_stone_bricks": "Заражене напукле камене цигле",
  "block.minecraft.infested_deepslate": "Заражен шкриљац",
  "block.minecraft.infested_mossy_stone_bricks": "Заражене камене цигле прекривене маховином",
  "block.minecraft.infested_stone": "Заражени камен",
  "block.minecraft.infested_stone_bricks": "Заражене камене цигле",
  "block.minecraft.iron_bars": "Гвоздене решетке",
  "block.minecraft.iron_block": "Гвоздени блок",
  "block.minecraft.iron_chain": "Гвоздени ланац",
  "block.minecraft.iron_door": "Гвоздена врата",
  "block.minecraft.iron_ore": "Руда гвожђа",
  "block.minecraft.iron_trapdoor": "Гвоздено окно",
  "block.minecraft.jack_o_lantern": "Светлећа бундева",
  "block.minecraft.jigsaw": "Блок слагалица",
  "block.minecraft.jukebox": "Џубокс",
  "block.minecraft.jungle_button": "Дугме од дрвета џунгле",
  "block.minecraft.jungle_door": "Врата од дрвета џунгле",
  "block.minecraft.jungle_fence": "Ограда од дрвета џунгле",
  "block.minecraft.jungle_fence_gate": "Капија од дрвета џунгле",
  "block.minecraft.jungle_hanging_sign": "Висећи знак од дрвета џунгле",
  "block.minecraft.jungle_leaves": "Лишће из џунгле",
  "block.minecraft.jungle_log": "Дрво џунгле",
  "block.minecraft.jungle_planks": "Даске од дрвета џунгле",
  "block.minecraft.jungle_pressure_plate": "Потисна плоча од дрвета џунгле",
  "block.minecraft.jungle_sapling": "Младица дрвета џунгле",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Знак од дрвета џунгле",
  "block.minecraft.jungle_slab": "Плоча од дрвета џунгле",
  "block.minecraft.jungle_stairs": "Степенице од дрвета џунгле",
  "block.minecraft.jungle_trapdoor": "Окно од дрвета џунгле",
  "block.minecraft.jungle_wall_hanging_sign": "Висећи зидни знак од дрвета џунгле",
  "block.minecraft.jungle_wall_sign": "Знак од дрвета џунгле",
  "block.minecraft.jungle_wood": "Дрво џунгле",
  "block.minecraft.kelp": "Келп",
  "block.minecraft.kelp_plant": "Морске алге",
  "block.minecraft.ladder": "Мердевине",
  "block.minecraft.lantern": "Фењер",
  "block.minecraft.lapis_block": "Блок лапис лазулија",
  "block.minecraft.lapis_ore": "Руда лапис лазулија",
  "block.minecraft.large_amethyst_bud": "Велики пупољак аметиста",
  "block.minecraft.large_fern": "Велики папрат",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Котао лаве",
  "block.minecraft.leaf_litter": "Осушено лишће",
  "block.minecraft.lectern": "Наслон за читање",
  "block.minecraft.lever": "Полуга",
  "block.minecraft.light": "Светло",
  "block.minecraft.light_blue_banner": "Светлоплава застава",
  "block.minecraft.light_blue_bed": "Светлоплав кревет",
  "block.minecraft.light_blue_candle": "Светлоплава свећа",
  "block.minecraft.light_blue_candle_cake": "Торта са светло плавом свећом",
  "block.minecraft.light_blue_carpet": "Светлоплави тепих",
  "block.minecraft.light_blue_concrete": "Светлоплави бетон",
  "block.minecraft.light_blue_concrete_powder": "Светлоплави бетон у праху",
  "block.minecraft.light_blue_glazed_terracotta": "Теракота са глазуром светлоплаве",
  "block.minecraft.light_blue_shulker_box": "Светлоплава Шулкер кутија",
  "block.minecraft.light_blue_stained_glass": "Светлоплаво обојено стакло",
  "block.minecraft.light_blue_stained_glass_pane": "Светлоплава стаклена плоча",
  "block.minecraft.light_blue_terracotta": "Светлоплава теракота",
  "block.minecraft.light_blue_wool": "Светлоплава вуна",
  "block.minecraft.light_gray_banner": "Светлосива застава",
  "block.minecraft.light_gray_bed": "Светлосив кревет",
  "block.minecraft.light_gray_candle": "Светлосива свећа",
  "block.minecraft.light_gray_candle_cake": "Торта са светлосивом свећом",
  "block.minecraft.light_gray_carpet": "Светлосиви тепих",
  "block.minecraft.light_gray_concrete": "Светлосиви бетон",
  "block.minecraft.light_gray_concrete_powder": "Светлосиви бетон у праху",
  "block.minecraft.light_gray_glazed_terracotta": "Теракота са глазуром светло сиве",
  "block.minecraft.light_gray_shulker_box": "Светлосива Шулкер кутија",
  "block.minecraft.light_gray_stained_glass": "Светлосиво обојено стакло",
  "block.minecraft.light_gray_stained_glass_pane": "Светлосива стаклена плоча",
  "block.minecraft.light_gray_terracotta": "Светлосива теракота",
  "block.minecraft.light_gray_wool": "Светлосива вуна",
  "block.minecraft.light_weighted_pressure_plate": "Лака потисна плоча",
  "block.minecraft.lightning_rod": "Громобран",
  "block.minecraft.lilac": "Јоргован",
  "block.minecraft.lily_of_the_valley": "Ђурђевак",
  "block.minecraft.lily_pad": "Локвањ",
  "block.minecraft.lime_banner": "Светлозелена застава",
  "block.minecraft.lime_bed": "Светлозелен кревет",
  "block.minecraft.lime_candle": "Светлозелена свећа",
  "block.minecraft.lime_candle_cake": "Торта са светлозеленом свећом",
  "block.minecraft.lime_carpet": "Светлозелени тепих",
  "block.minecraft.lime_concrete": "Светлозелени бетон",
  "block.minecraft.lime_concrete_powder": "Светлозелени бетон у праху",
  "block.minecraft.lime_glazed_terracotta": "Теракота са глазуром светло зелене",
  "block.minecraft.lime_shulker_box": "Светлозелена Шулкер кутија",
  "block.minecraft.lime_stained_glass": "Светлозелено обојено стакло",
  "block.minecraft.lime_stained_glass_pane": "Светлозелена стаклена плоча",
  "block.minecraft.lime_terracotta": "Светлозелена теракота",
  "block.minecraft.lime_wool": "Светлозелена вуна",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Разбој",
  "block.minecraft.magenta_banner": "Магента застава",
  "block.minecraft.magenta_bed": "Магента кревет",
  "block.minecraft.magenta_candle": "Магента свећа",
  "block.minecraft.magenta_candle_cake": "Торта са магента свећом",
  "block.minecraft.magenta_carpet": "Магента тепих",
  "block.minecraft.magenta_concrete": "Магента бетон",
  "block.minecraft.magenta_concrete_powder": "Магента бетон у праху",
  "block.minecraft.magenta_glazed_terracotta": "Теракота са магента глазуром",
  "block.minecraft.magenta_shulker_box": "Магента Шулкер кутија",
  "block.minecraft.magenta_stained_glass": "Магента обојено стакло",
  "block.minecraft.magenta_stained_glass_pane": "Магента стаклена плоча",
  "block.minecraft.magenta_terracotta": "Магента теракота",
  "block.minecraft.magenta_wool": "Магента вуна",
  "block.minecraft.magma_block": "Блок магме",
  "block.minecraft.mangrove_button": "Дугме од мангрова",
  "block.minecraft.mangrove_door": "Врата од мангрова",
  "block.minecraft.mangrove_fence": "Ограда од мангрова",
  "block.minecraft.mangrove_fence_gate": "Капија од мангрова",
  "block.minecraft.mangrove_hanging_sign": "Мангровин висећи знак",
  "block.minecraft.mangrove_leaves": "Листови мангрова",
  "block.minecraft.mangrove_log": "Мангрова",
  "block.minecraft.mangrove_planks": "Даске од мангрова",
  "block.minecraft.mangrove_pressure_plate": "Потисна плоча од мангрова",
  "block.minecraft.mangrove_propagule": "Пропагула мангрова",
  "block.minecraft.mangrove_roots": "Корење мангрова",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Знак од мангрова",
  "block.minecraft.mangrove_slab": "Плоча мангрова",
  "block.minecraft.mangrove_stairs": "Степенице од мангрова",
  "block.minecraft.mangrove_trapdoor": "Окно од мангрова",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангровин зидни висећи знак",
  "block.minecraft.mangrove_wall_sign": "Зидни знак од мангрова",
  "block.minecraft.mangrove_wood": "Дрво мангровa",
  "block.minecraft.medium_amethyst_bud": "Средњи пупољак аметиста",
  "block.minecraft.melon": "Лубеница",
  "block.minecraft.melon_stem": "Стабљика лубенице",
  "block.minecraft.moss_block": "Блок маховине",
  "block.minecraft.moss_carpet": "Тепих од маховине",
  "block.minecraft.mossy_cobblestone": "Калдрма са маховином",
  "block.minecraft.mossy_cobblestone_slab": "Плоча од камена са маховином",
  "block.minecraft.mossy_cobblestone_stairs": "Степенице од камења са маховином",
  "block.minecraft.mossy_cobblestone_wall": "Зид од калдрме са маховином",
  "block.minecraft.mossy_stone_brick_slab": "Плоча од камења са маховином",
  "block.minecraft.mossy_stone_brick_stairs": "Степенице од цигли са маховином",
  "block.minecraft.mossy_stone_brick_wall": "Зид од камених цигли са маховином",
  "block.minecraft.mossy_stone_bricks": "Камене цигле прекривене маховином",
  "block.minecraft.moving_piston": "Померајући клип",
  "block.minecraft.mud": "Блато",
  "block.minecraft.mud_brick_slab": "Ћерпична плоча",
  "block.minecraft.mud_brick_stairs": "Ћерпичне цигле",
  "block.minecraft.mud_brick_wall": "Ћерпични зид",
  "block.minecraft.mud_bricks": "Ћерпич",
  "block.minecraft.muddy_mangrove_roots": "Блатњаво корење мангрова",
  "block.minecraft.mushroom_stem": "Стабљика печурке",
  "block.minecraft.mycelium": "Мицелијум",
  "block.minecraft.nether_brick_fence": "Ограда од Недер цигли",
  "block.minecraft.nether_brick_slab": "Недер циглена плоча",
  "block.minecraft.nether_brick_stairs": "Степенице од Недер цигли",
  "block.minecraft.nether_brick_wall": "Зид од цигли из Недера",
  "block.minecraft.nether_bricks": "Недер циглe",
  "block.minecraft.nether_gold_ore": "Руда Недер злата",
  "block.minecraft.nether_portal": "Недер портал",
  "block.minecraft.nether_quartz_ore": "Руда Недер кварца",
  "block.minecraft.nether_sprouts": "Недер клице",
  "block.minecraft.nether_wart": "Недер лишај",
  "block.minecraft.nether_wart_block": "Блок Недер лишаја",
  "block.minecraft.netherite_block": "Блок Недерита",
  "block.minecraft.netherrack": "Недерек",
  "block.minecraft.note_block": "Музички блок",
  "block.minecraft.oak_button": "Храстово дугме",
  "block.minecraft.oak_door": "Храстова врата",
  "block.minecraft.oak_fence": "Храстова ограда",
  "block.minecraft.oak_fence_gate": "Храстова капија",
  "block.minecraft.oak_hanging_sign": "Храстов висећи знак",
  "block.minecraft.oak_leaves": "Храстово лишће",
  "block.minecraft.oak_log": "Храстов пањ",
  "block.minecraft.oak_planks": "Храстове даске",
  "block.minecraft.oak_pressure_plate": "Храстова потисна плоча",
  "block.minecraft.oak_sapling": "Храстове младице",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Храстов знак",
  "block.minecraft.oak_slab": "Храстова плоча",
  "block.minecraft.oak_stairs": "Храстове степенице",
  "block.minecraft.oak_trapdoor": "Храстово окно",
  "block.minecraft.oak_wall_hanging_sign": "Храстов зидни висећи знак",
  "block.minecraft.oak_wall_sign": "Храстов зидни знак",
  "block.minecraft.oak_wood": "Храстовина",
  "block.minecraft.observer": "Посматрач",
  "block.minecraft.obsidian": "Обсидијан",
  "block.minecraft.ochre_froglight": "Окер жампа",
  "block.minecraft.ominous_banner": "Злослутан барјак",
  "block.minecraft.open_eyeblossom": "Отворен окоцвет",
  "block.minecraft.orange_banner": "Наранџаста застава",
  "block.minecraft.orange_bed": "Наранџасти кревет",
  "block.minecraft.orange_candle": "Наранџaста свећа",
  "block.minecraft.orange_candle_cake": "Торта са наранџастом свећом",
  "block.minecraft.orange_carpet": "Наранџасти тепих",
  "block.minecraft.orange_concrete": "Наранџасти бетон",
  "block.minecraft.orange_concrete_powder": "Наранџасти бетон у праху",
  "block.minecraft.orange_glazed_terracotta": "Теракота са глазуром наранџасте",
  "block.minecraft.orange_shulker_box": "Наранџаста Шулкер кутија",
  "block.minecraft.orange_stained_glass": "Наранџасто обојено стакло",
  "block.minecraft.orange_stained_glass_pane": "Наранџаста стаклена плоча",
  "block.minecraft.orange_terracotta": "Наранџаста теракота",
  "block.minecraft.orange_tulip": "Наранџаста лала",
  "block.minecraft.orange_wool": "Наранџаста вуна",
  "block.minecraft.oxeye_daisy": "Бела рада",
  "block.minecraft.oxidized_chiseled_copper": "Оксидовани клесани бакар",
  "block.minecraft.oxidized_copper": "Оксидовани бакар",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Оксидовани бакарна сијалица",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Оксидовани бакарна врата",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Оксидовани бакарна капија",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Оксидовани бакарна трапдоор",
  "block.minecraft.oxidized_cut_copper": "Оксидовани сечени бакар",
  "block.minecraft.oxidized_cut_copper_slab": "Оксидована плоча од сеченог бакра",
  "block.minecraft.oxidized_cut_copper_stairs": "Оксидоване степенице од сеченог бакра",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Дебели лед",
  "block.minecraft.packed_mud": "Дебело блато",
  "block.minecraft.pale_hanging_moss": "Бледа висећа маховина",
  "block.minecraft.pale_moss_block": "Бледи блок маховине",
  "block.minecraft.pale_moss_carpet": "Бледи тепих од маховине",
  "block.minecraft.pale_oak_button": "Бледо храстово дугме",
  "block.minecraft.pale_oak_door": "Бледа храстова врата",
  "block.minecraft.pale_oak_fence": "Бледа храстова ограда",
  "block.minecraft.pale_oak_fence_gate": "Бледа храстова капија",
  "block.minecraft.pale_oak_hanging_sign": "Бледи храстов висећи знак",
  "block.minecraft.pale_oak_leaves": "Лишће бледог храста",
  "block.minecraft.pale_oak_log": "Бледи храстов пањ",
  "block.minecraft.pale_oak_planks": "Бледе храстове даске",
  "block.minecraft.pale_oak_pressure_plate": "Бледа храстова потисна плоча",
  "block.minecraft.pale_oak_sapling": "Младица бледог храста",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Бледи храстов знак",
  "block.minecraft.pale_oak_slab": "Бледа храстова плоча",
  "block.minecraft.pale_oak_stairs": "Бледе храстове степенице",
  "block.minecraft.pale_oak_trapdoor": "Бледо храстово окно",
  "block.minecraft.pale_oak_wall_hanging_sign": "Бледи храстов зидни висећи знак",
  "block.minecraft.pale_oak_wall_sign": "Бледи храстов зидни знак",
  "block.minecraft.pale_oak_wood": "Бледо храстово дрво",
  "block.minecraft.pearlescent_froglight": "Бисерна жампа",
  "block.minecraft.peony": "Божур",
  "block.minecraft.petrified_oak_slab": "Окамењена храстова плоча",
  "block.minecraft.piglin_head": "Пиглинова глава",
  "block.minecraft.piglin_wall_head": "Пиглинова зидна глава",
  "block.minecraft.pink_banner": "Розе застава",
  "block.minecraft.pink_bed": "Розе кревет",
  "block.minecraft.pink_candle": "Розе свећа",
  "block.minecraft.pink_candle_cake": "Торта са пинк свећом",
  "block.minecraft.pink_carpet": "Розе тепих",
  "block.minecraft.pink_concrete": "Розе бетон",
  "block.minecraft.pink_concrete_powder": "Розе бетон у праху",
  "block.minecraft.pink_glazed_terracotta": "Теракота са розе глазуром",
  "block.minecraft.pink_petals": "Розе латице",
  "block.minecraft.pink_shulker_box": "Роза Шулкер кутија",
  "block.minecraft.pink_stained_glass": "Розе обојено стакло",
  "block.minecraft.pink_stained_glass_pane": "Розе стаклена плоча",
  "block.minecraft.pink_terracotta": "Розе теракота",
  "block.minecraft.pink_tulip": "Розе лала",
  "block.minecraft.pink_wool": "Розе вуна",
  "block.minecraft.piston": "Клип",
  "block.minecraft.piston_head": "Глава од клипа",
  "block.minecraft.pitcher_crop": "Садница врча",
  "block.minecraft.pitcher_plant": "Биљка врч",
  "block.minecraft.player_head": "Глава играча",
  "block.minecraft.player_head.named": "Глава од \"%s\"",
  "block.minecraft.player_wall_head": "Зидна глава играча",
  "block.minecraft.podzol": "Подзол",
  "block.minecraft.pointed_dripstone": "Шиљати капмен",
  "block.minecraft.polished_andesite": "Углачани андезит",
  "block.minecraft.polished_andesite_slab": "Углачана плоча од андезита",
  "block.minecraft.polished_andesite_stairs": "Углачане степенице од андезита",
  "block.minecraft.polished_basalt": "Углачани базалт",
  "block.minecraft.polished_blackstone": "Углачана црна калдрма",
  "block.minecraft.polished_blackstone_brick_slab": "Углачана плоча од цигала црне калдрме",
  "block.minecraft.polished_blackstone_brick_stairs": "Углачане степенице од цигала црне калдрме",
  "block.minecraft.polished_blackstone_brick_wall": "Углачани зид од цигала црне калдрме",
  "block.minecraft.polished_blackstone_bricks": "Углачане цигле од црне калдрме",
  "block.minecraft.polished_blackstone_button": "Дугме од углачане црне калдрме",
  "block.minecraft.polished_blackstone_pressure_plate": "Потисна плоча од углачане црне калдрме",
  "block.minecraft.polished_blackstone_slab": "Плоча од углачане црне калдрме",
  "block.minecraft.polished_blackstone_stairs": "Степенице од углачане црне калдрме",
  "block.minecraft.polished_blackstone_wall": "Зид од углачане црне калдрме",
  "block.minecraft.polished_deepslate": "Полирани шкриљац",
  "block.minecraft.polished_deepslate_slab": "Плоча полираног шкриљца",
  "block.minecraft.polished_deepslate_stairs": "Степенице полираног шкриљца",
  "block.minecraft.polished_deepslate_wall": "Зид полираног шкриљца",
  "block.minecraft.polished_diorite": "Углачани диорит",
  "block.minecraft.polished_diorite_slab": "Углачана плоча од диорита",
  "block.minecraft.polished_diorite_stairs": "Углачане степенице од диорита",
  "block.minecraft.polished_granite": "Углачани гранит",
  "block.minecraft.polished_granite_slab": "Углачана плоча од гранита",
  "block.minecraft.polished_granite_stairs": "Углачане степенице од гранита",
  "block.minecraft.polished_tuff": "Полирани туф",
  "block.minecraft.polished_tuff_slab": "Углачан туф плоча",
  "block.minecraft.polished_tuff_stairs": "Углачан туф степенице",
  "block.minecraft.polished_tuff_wall": "Углачан туф зид",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Кромпири",
  "block.minecraft.potted_acacia_sapling": "Засађена младица багрема",
  "block.minecraft.potted_allium": "Алијум у саксији",
  "block.minecraft.potted_azalea_bush": "Засађена азалеја",
  "block.minecraft.potted_azure_bluet": "Хустонија у саксији",
  "block.minecraft.potted_bamboo": "Бамбус у саксији",
  "block.minecraft.potted_birch_sapling": "Засађена брезова младица",
  "block.minecraft.potted_blue_orchid": "Плава орхидеја у саксији",
  "block.minecraft.potted_brown_mushroom": "Браон печурка у саксији",
  "block.minecraft.potted_cactus": "Засађен кактус",
  "block.minecraft.potted_cherry_sapling": "Засађена трешњина младица",
  "block.minecraft.potted_closed_eyeblossom": "Затворен окоцвет у саксији",
  "block.minecraft.potted_cornflower": "Различак у саксији",
  "block.minecraft.potted_crimson_fungus": "Гримизна гљива у саксији",
  "block.minecraft.potted_crimson_roots": "Гримизно корење у саксији",
  "block.minecraft.potted_dandelion": "Маслачак у саксији",
  "block.minecraft.potted_dark_oak_sapling": "Засађена младица тамног храста",
  "block.minecraft.potted_dead_bush": "Увели жбун у саксији",
  "block.minecraft.potted_fern": "Папрат у саксији",
  "block.minecraft.potted_flowering_azalea_bush": "Цветајућа засађена азалеја",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Засађена младица дрвета џунгле",
  "block.minecraft.potted_lily_of_the_valley": "Ђурђевак у саксији",
  "block.minecraft.potted_mangrove_propagule": "Пропагула мангрове у саксији",
  "block.minecraft.potted_oak_sapling": "Засађена храстова младица",
  "block.minecraft.potted_open_eyeblossom": "Отворен окоцвет у саксији",
  "block.minecraft.potted_orange_tulip": "Наранџаста лала у саксији",
  "block.minecraft.potted_oxeye_daisy": "Бела рада у саксији",
  "block.minecraft.potted_pale_oak_sapling": "Засађена младица бледог храста",
  "block.minecraft.potted_pink_tulip": "Розе лала у саксији",
  "block.minecraft.potted_poppy": "Мак у саксији",
  "block.minecraft.potted_red_mushroom": "Црвена печурка у саксији",
  "block.minecraft.potted_red_tulip": "Црвена лала у саксији",
  "block.minecraft.potted_spruce_sapling": "Засађена младица смреке",
  "block.minecraft.potted_torchflower": "Бакљоцвет у саксији",
  "block.minecraft.potted_warped_fungus": "Изопачена гљива у саксији",
  "block.minecraft.potted_warped_roots": "Изопачено корење у саксији",
  "block.minecraft.potted_white_tulip": "Бела лала у саксији",
  "block.minecraft.potted_wither_rose": "Видер ружа у саксији",
  "block.minecraft.powder_snow": "Снег у праху",
  "block.minecraft.powder_snow_cauldron": "Котао са снегом у праху",
  "block.minecraft.powered_rail": "Пруга под напоном",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Плоча од призмаринских цигли",
  "block.minecraft.prismarine_brick_stairs": "Степенице од призмаринских цигли",
  "block.minecraft.prismarine_bricks": "Блок призмарина",
  "block.minecraft.prismarine_slab": "Плоча призмарина",
  "block.minecraft.prismarine_stairs": "Cтепенице призмарина",
  "block.minecraft.prismarine_wall": "Зид од призмарина",
  "block.minecraft.pumpkin": "Бундева",
  "block.minecraft.pumpkin_stem": "Стабљика бундеве",
  "block.minecraft.purple_banner": "Љубичаста застава",
  "block.minecraft.purple_bed": "Љубичаст кревет",
  "block.minecraft.purple_candle": "Љубичаста свећа",
  "block.minecraft.purple_candle_cake": "Торта са љубичастом свећом",
  "block.minecraft.purple_carpet": "Љубичасти тепих",
  "block.minecraft.purple_concrete": "Љубичасти бетон",
  "block.minecraft.purple_concrete_powder": "Љубичасти бетон у праху",
  "block.minecraft.purple_glazed_terracotta": "Теракота са глазуром љубичасте",
  "block.minecraft.purple_shulker_box": "Љубичаста Шулкер кутија",
  "block.minecraft.purple_stained_glass": "Љубичасто обојено стакло",
  "block.minecraft.purple_stained_glass_pane": "Љубичаста стаклена плоча",
  "block.minecraft.purple_terracotta": "Љубичаста теракота",
  "block.minecraft.purple_wool": "Љубичаста вуна",
  "block.minecraft.purpur_block": "Пурпур блок",
  "block.minecraft.purpur_pillar": "Пурпур стуб",
  "block.minecraft.purpur_slab": "Пурпур плоча",
  "block.minecraft.purpur_stairs": "Пурпур степенице",
  "block.minecraft.quartz_block": "Блок кварца",
  "block.minecraft.quartz_bricks": "Цигле од кварца",
  "block.minecraft.quartz_pillar": "Стуб од кварца",
  "block.minecraft.quartz_slab": "Плоча од кварца",
  "block.minecraft.quartz_stairs": "Степенице од кварца",
  "block.minecraft.rail": "Пруга",
  "block.minecraft.raw_copper_block": "Блок сировог бакра",
  "block.minecraft.raw_gold_block": "Блок сировог злата",
  "block.minecraft.raw_iron_block": "Блок сировог гвожђа",
  "block.minecraft.red_banner": "Црвена застава",
  "block.minecraft.red_bed": "Црвен кревет",
  "block.minecraft.red_candle": "Црвена свећа",
  "block.minecraft.red_candle_cake": "Торта са црвеном свећом",
  "block.minecraft.red_carpet": "Црвени тепих",
  "block.minecraft.red_concrete": "Црвени бетон",
  "block.minecraft.red_concrete_powder": "Црвени бетон у праху",
  "block.minecraft.red_glazed_terracotta": "Теракота са глазуром црвене",
  "block.minecraft.red_mushroom": "Црвена печурка",
  "block.minecraft.red_mushroom_block": "Блок црвене печурке",
  "block.minecraft.red_nether_brick_slab": "Црвена недер циглена плоча",
  "block.minecraft.red_nether_brick_stairs": "Степенице од црвених Недер цигли",
  "block.minecraft.red_nether_brick_wall": "Зид од црвених цигли из Недера",
  "block.minecraft.red_nether_bricks": "Црвене Недер цигле",
  "block.minecraft.red_sand": "Црвени песак",
  "block.minecraft.red_sandstone": "Црвени пешчар",
  "block.minecraft.red_sandstone_slab": "Плоча црвеног пешчара",
  "block.minecraft.red_sandstone_stairs": "Степенице црвеног пешчара",
  "block.minecraft.red_sandstone_wall": "Зид од црвеног пешчара",
  "block.minecraft.red_shulker_box": "Црвена Шулкер кутија",
  "block.minecraft.red_stained_glass": "Црвено обојено стакло",
  "block.minecraft.red_stained_glass_pane": "Црвена стаклена плоча",
  "block.minecraft.red_terracotta": "Црвена теракота",
  "block.minecraft.red_tulip": "Црвена лала",
  "block.minecraft.red_wool": "Црвена вуна",
  "block.minecraft.redstone_block": "Редстоун блок",
  "block.minecraft.redstone_lamp": "Редстоун лампа",
  "block.minecraft.redstone_ore": "Редстоун руда",
  "block.minecraft.redstone_torch": "Редстоун бакља",
  "block.minecraft.redstone_wall_torch": "Зидна редстоун бакља",
  "block.minecraft.redstone_wire": "Редстоун жица",
  "block.minecraft.reinforced_deepslate": "Ојачани шкриљац",
  "block.minecraft.repeater": "Редстоун појачивач",
  "block.minecraft.repeating_command_block": "Понављајући командни блок",
  "block.minecraft.resin_block": "Блок смоле",
  "block.minecraft.resin_brick_slab": "Циглена плоча смоле",
  "block.minecraft.resin_brick_stairs": "Степенице од смолених цигала",
  "block.minecraft.resin_brick_wall": "Зид од смолених цигала",
  "block.minecraft.resin_bricks": "Смолене цигле",
  "block.minecraft.resin_clump": "Грудвица смоле",
  "block.minecraft.respawn_anchor": "Реинкарнационо сидро",
  "block.minecraft.rooted_dirt": "Укорењена земља",
  "block.minecraft.rose_bush": "Жбун ружа",
  "block.minecraft.sand": "Песак",
  "block.minecraft.sandstone": "Пешчар",
  "block.minecraft.sandstone_slab": "Пешчарска плоча",
  "block.minecraft.sandstone_stairs": "Степенице од пешчара",
  "block.minecraft.sandstone_wall": "Зид од пешчара",
  "block.minecraft.scaffolding": "Скеле",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк катализатор",
  "block.minecraft.sculk_sensor": "Скалк сензор",
  "block.minecraft.sculk_shrieker": "Скалк вриштач",
  "block.minecraft.sculk_vein": "Скалк жила",
  "block.minecraft.sea_lantern": "Морски фењер",
  "block.minecraft.sea_pickle": "Морски краставац",
  "block.minecraft.seagrass": "Морска трава",
  "block.minecraft.set_spawn": "Постављена тачка реинкарнације",
  "block.minecraft.short_dry_grass": "Ниска сува трава",
  "block.minecraft.short_grass": "Ниска трава",
  "block.minecraft.shroomlight": "Светлопечурка",
  "block.minecraft.shulker_box": "Шулкер кутија",
  "block.minecraft.skeleton_skull": "Костурова лобања",
  "block.minecraft.skeleton_wall_skull": "Зидна костурова лобања",
  "block.minecraft.slime_block": "Блок слузи",
  "block.minecraft.small_amethyst_bud": "Мали пупољак аметиста",
  "block.minecraft.small_dripleaf": "Мали кап-лист",
  "block.minecraft.smithing_table": "Ковачки сто",
  "block.minecraft.smoker": "Пушница",
  "block.minecraft.smooth_basalt": "Глатки базалт",
  "block.minecraft.smooth_quartz": "Гладак блок кварца",
  "block.minecraft.smooth_quartz_slab": "Глатка плоча од кварца",
  "block.minecraft.smooth_quartz_stairs": "Глатке степенице од кварца",
  "block.minecraft.smooth_red_sandstone": "Гладак црвени пешкар",
  "block.minecraft.smooth_red_sandstone_slab": "Глатка плоча од црвеног пешчара",
  "block.minecraft.smooth_red_sandstone_stairs": "Глатке степенице од црвеног пешчара",
  "block.minecraft.smooth_sandstone": "Гладак пешчар",
  "block.minecraft.smooth_sandstone_slab": "Глатка плоча од пешчара",
  "block.minecraft.smooth_sandstone_stairs": "Глатке степенице од пешчара",
  "block.minecraft.smooth_stone": "Гладак камен",
  "block.minecraft.smooth_stone_slab": "Глатка камена плоча",
  "block.minecraft.sniffer_egg": "Њушкалово јаје",
  "block.minecraft.snow": "Снег",
  "block.minecraft.snow_block": "Снежни блок",
  "block.minecraft.soul_campfire": "Душевна логорска ватра",
  "block.minecraft.soul_fire": "Душевна ватра",
  "block.minecraft.soul_lantern": "Фењер душа",
  "block.minecraft.soul_sand": "Песак душа",
  "block.minecraft.soul_soil": "Душевно тло",
  "block.minecraft.soul_torch": "Бакља душа",
  "block.minecraft.soul_wall_torch": "Зидна бакља души",
  "block.minecraft.spawn.not_valid": "Кревет или напуњено реинкарнационо сидро не постоји, или је уништено",
  "block.minecraft.spawner": "Генератор чудовишта",
  "block.minecraft.spawner.desc1": "Интеракција с јајетом за стварање:",
  "block.minecraft.spawner.desc2": "Поставља врсту створења",
  "block.minecraft.sponge": "Сунђер",
  "block.minecraft.spore_blossom": "Пупољак споре",
  "block.minecraft.spruce_button": "Дугме од смреке",
  "block.minecraft.spruce_door": "Врата од смреке",
  "block.minecraft.spruce_fence": "Ограда од смреке",
  "block.minecraft.spruce_fence_gate": "Капија од смреке",
  "block.minecraft.spruce_hanging_sign": "Смрекин висећи знак",
  "block.minecraft.spruce_leaves": "Лишће смреке",
  "block.minecraft.spruce_log": "Смрека",
  "block.minecraft.spruce_planks": "Даске од смреке",
  "block.minecraft.spruce_pressure_plate": "Потисна плоча од смреке",
  "block.minecraft.spruce_sapling": "Младица смреке",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Знак од смреке",
  "block.minecraft.spruce_slab": "Плоча од смреке",
  "block.minecraft.spruce_stairs": "Степенице од смреке",
  "block.minecraft.spruce_trapdoor": "Окно од смреке",
  "block.minecraft.spruce_wall_hanging_sign": "Оморикин зидни висећи знак",
  "block.minecraft.spruce_wall_sign": "Знак од смреке за зид",
  "block.minecraft.spruce_wood": "Дрво смреке",
  "block.minecraft.sticky_piston": "Лепљиви клип",
  "block.minecraft.stone": "Камен",
  "block.minecraft.stone_brick_slab": "Плоча од камених цигала",
  "block.minecraft.stone_brick_stairs": "Степенице од камене цигле",
  "block.minecraft.stone_brick_wall": "Зид од камених цигли",
  "block.minecraft.stone_bricks": "Камене цигле",
  "block.minecraft.stone_button": "Камено дугме",
  "block.minecraft.stone_pressure_plate": "Камена потисна плоча",
  "block.minecraft.stone_slab": "Камена плоча",
  "block.minecraft.stone_stairs": "Степенице од камења",
  "block.minecraft.stonecutter": "Резач камена",
  "block.minecraft.stripped_acacia_log": "Огуљена акација",
  "block.minecraft.stripped_acacia_wood": "Огуљено дрво багрема",
  "block.minecraft.stripped_bamboo_block": "Блок од огуљеног бамбуса",
  "block.minecraft.stripped_birch_log": "Огуљен брезов пањ",
  "block.minecraft.stripped_birch_wood": "Огуљена брезовина",
  "block.minecraft.stripped_cherry_log": "Огуљено трешњино дрво",
  "block.minecraft.stripped_cherry_wood": "Огуљено трешњино дрво",
  "block.minecraft.stripped_crimson_hyphae": "Огуљена гримизна хифа",
  "block.minecraft.stripped_crimson_stem": "Огуљена гримизна стабљика",
  "block.minecraft.stripped_dark_oak_log": "Огуљени тамни храстов пањ",
  "block.minecraft.stripped_dark_oak_wood": "Огуљена тамна храстовина",
  "block.minecraft.stripped_jungle_log": "Огуљено дрвo џунгле",
  "block.minecraft.stripped_jungle_wood": "Огуљено дрвo џунгле",
  "block.minecraft.stripped_mangrove_log": "Огyљена мангровa",
  "block.minecraft.stripped_mangrove_wood": "Огуљено дрво мангрова",
  "block.minecraft.stripped_oak_log": "Огуљени храстов пањ",
  "block.minecraft.stripped_oak_wood": "Огуљена храстовина",
  "block.minecraft.stripped_pale_oak_log": "Огуљени бледи храстов пањ",
  "block.minecraft.stripped_pale_oak_wood": "Огуљено бледо храстово дрво",
  "block.minecraft.stripped_spruce_log": "Огуљена смрека",
  "block.minecraft.stripped_spruce_wood": "Огуљено дрво смреке",
  "block.minecraft.stripped_warped_hyphae": "Огуљена изопачена хифа",
  "block.minecraft.stripped_warped_stem": "Огуљена изопачена стабљика",
  "block.minecraft.structure_block": "Структурни блок",
  "block.minecraft.structure_void": "Структурна празнина",
  "block.minecraft.sugar_cane": "Шећерна трска",
  "block.minecraft.sunflower": "Сунцокрет",
  "block.minecraft.suspicious_gravel": "Сумњиви шљунак",
  "block.minecraft.suspicious_sand": "Сумњиви песак",
  "block.minecraft.sweet_berry_bush": "Слатки жбун бобица",
  "block.minecraft.tall_dry_grass": "Висока сува трава",
  "block.minecraft.tall_grass": "Висока трава",
  "block.minecraft.tall_seagrass": "Висока морска трава",
  "block.minecraft.target": "Мета",
  "block.minecraft.terracotta": "Теракота",
  "block.minecraft.test_block": "Тест блок",
  "block.minecraft.test_instance_block": "Тест блок инстанце",
  "block.minecraft.tinted_glass": "Замагљено стакло",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Бакља",
  "block.minecraft.torchflower": "Бакљоцвет",
  "block.minecraft.torchflower_crop": "Усев бакљоцвета",
  "block.minecraft.trapped_chest": "Ковчег са замком",
  "block.minecraft.trial_spawner": "Стварач Изазова",
  "block.minecraft.tripwire": "Нагазна жица",
  "block.minecraft.tripwire_hook": "Кука за нагазну жицу",
  "block.minecraft.tube_coral": "Цевасти корал",
  "block.minecraft.tube_coral_block": "Блок цевастог корала",
  "block.minecraft.tube_coral_fan": "Цеваста корална лепеза",
  "block.minecraft.tube_coral_wall_fan": "Цеваста корална зидна лепеза",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф цигла плоча",
  "block.minecraft.tuff_brick_stairs": "Туф цигла степенице",
  "block.minecraft.tuff_brick_wall": "Туф цигла зид",
  "block.minecraft.tuff_bricks": "Туф цигле",
  "block.minecraft.tuff_slab": "Туф плоча",
  "block.minecraft.tuff_stairs": "Туф степенице",
  "block.minecraft.tuff_wall": "Туф зид",
  "block.minecraft.turtle_egg": "Корњачино јаје",
  "block.minecraft.twisting_vines": "Уврнуте лијане",
  "block.minecraft.twisting_vines_plant": "Биљка уврнуте лијане",
  "block.minecraft.vault": "Трезор",
  "block.minecraft.verdant_froglight": "Зелена жампа",
  "block.minecraft.vine": "Лијане",
  "block.minecraft.void_air": "Празни ваздух",
  "block.minecraft.wall_torch": "Зидна бакља",
  "block.minecraft.warped_button": "Изопачено дугме",
  "block.minecraft.warped_door": "Изопачена врата",
  "block.minecraft.warped_fence": "Изопачена ограда",
  "block.minecraft.warped_fence_gate": "Изопачена капија",
  "block.minecraft.warped_fungus": "Изопачена гљива",
  "block.minecraft.warped_hanging_sign": "Изопачени висећи знак",
  "block.minecraft.warped_hyphae": "Изопачена хифа",
  "block.minecraft.warped_nylium": "Изопачени нилијум",
  "block.minecraft.warped_planks": "Изопачене даске",
  "block.minecraft.warped_pressure_plate": "Изопачена потисна плоча",
  "block.minecraft.warped_roots": "Изопачено корење",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Изопачени знак",
  "block.minecraft.warped_slab": "Изопачена плоча",
  "block.minecraft.warped_stairs": "Изопачене степенице",
  "block.minecraft.warped_stem": "Изопачена стабљика",
  "block.minecraft.warped_trapdoor": "Изопачено окно",
  "block.minecraft.warped_wall_hanging_sign": "Изопачени зидни висећи знак",
  "block.minecraft.warped_wall_sign": "Изопачен зидни знак",
  "block.minecraft.warped_wart_block": "Изопачени Блок од Лишајева",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Котао воде",
  "block.minecraft.waxed_chiseled_copper": "Воштани клесани бакар",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Блок бакра обложен воском",
  "block.minecraft.waxed_copper_bulb": "Воштани клесани сијалица",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Воштани клесани врата",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Воштани клесани капија",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Депилирана бакарна замка",
  "block.minecraft.waxed_cut_copper": "Сечени бакар обложен воском",
  "block.minecraft.waxed_cut_copper_slab": "Плоча од сеченог бакра обложена воском",
  "block.minecraft.waxed_cut_copper_stairs": "Степенице од сеченог бакра обложене воском",
  "block.minecraft.waxed_exposed_chiseled_copper": "Воштани изложени исклесани бакар",
  "block.minecraft.waxed_exposed_copper": "Изложени бакар обложен воском",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Воштана изложена бакарна сијалица",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Депилација изложених бакарних врата",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Воштана изложена бакарна решетка",
  "block.minecraft.waxed_exposed_copper_lantern": "Воштани изложени бакарни фењер",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Депилирано изложен бакарни трапдоор",
  "block.minecraft.waxed_exposed_cut_copper": "Изложени сечени бакар обложен воском",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Изложена плоча од сеченог бакра обложена воском",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Изложене степенице од сеченог бакра обложене воском",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Воштани оксидирани исклесани бакар",
  "block.minecraft.waxed_oxidized_copper": "Оксидовани бакар обложен воском",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Воштана оксидирана бакарна сијалица",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Депилирана оксидирана бакарна врата",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Воштана оксидирана бакарна решетка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Воштана оксидирана бакарна замка",
  "block.minecraft.waxed_oxidized_cut_copper": "Оксидовани сечени бакар обложен воском",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Оксидована плоча од сеченог бакра обложена воском",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Степенице од сеченог бакра обложене воском",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Воштани прогнозирани исклесани бакар",
  "block.minecraft.waxed_weathered_copper": "Застарели бакар обложен воском",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Депилирано прогнозирана бакарна сијалица",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Воштана прогнозирана бакарна врата",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Воштана рендана бакарна решетка",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Депилирана бакарна замка",
  "block.minecraft.waxed_weathered_cut_copper": "Застарели сечени бакар обложен воском",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Застарела плоча од сеченог бакра обложена воском",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Застареле степенице од сеченог бакра обложене воском",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Прогнозирани исклесани бакар",
  "block.minecraft.weathered_copper": "Оксидован бакар",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Прогнозирана бакарна сијалица",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Прогнозирана бакарна врата",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Прогнозирана бакарна решетка",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Wеатхеред Цоппер Трапдоор",
  "block.minecraft.weathered_cut_copper": "Оксидован сечени бакар",
  "block.minecraft.weathered_cut_copper_slab": "Оксидована плоча од сеченог бакра",
  "block.minecraft.weathered_cut_copper_stairs": "Оксидоване степенице од сеченог бакра",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Јецајуће лијане",
  "block.minecraft.weeping_vines_plant": "Биљка јецајуће лијане",
  "block.minecraft.wet_sponge": "Мокар сунђер",
  "block.minecraft.wheat": "Усев пшенице",
  "block.minecraft.white_banner": "Бела застава",
  "block.minecraft.white_bed": "Бео кревет",
  "block.minecraft.white_candle": "Бела свећа",
  "block.minecraft.white_candle_cake": "Торта са белом свећом",
  "block.minecraft.white_carpet": "Бели тепих",
  "block.minecraft.white_concrete": "Бели бетон",
  "block.minecraft.white_concrete_powder": "Бели бетон у праху",
  "block.minecraft.white_glazed_terracotta": "Теракота са глазуром беле",
  "block.minecraft.white_shulker_box": "Бела Шулкер кутија",
  "block.minecraft.white_stained_glass": "Бело обојено стакло",
  "block.minecraft.white_stained_glass_pane": "Бела стаклена плоча",
  "block.minecraft.white_terracotta": "Бела теракота",
  "block.minecraft.white_tulip": "Бела лала",
  "block.minecraft.white_wool": "Бела вуна",
  "block.minecraft.wildflowers": "Дивље цвеће",
  "block.minecraft.wither_rose": "Видер ружа",
  "block.minecraft.wither_skeleton_skull": "Лобања Видер костура",
  "block.minecraft.wither_skeleton_wall_skull": "Зидна лобања Видер костура",
  "block.minecraft.yellow_banner": "Жута застава",
  "block.minecraft.yellow_bed": "Жут кревет",
  "block.minecraft.yellow_candle": "Жута свећа",
  "block.minecraft.yellow_candle_cake": "Торта са жутом свећом",
  "block.minecraft.yellow_carpet": "Жути тепих",
  "block.minecraft.yellow_concrete": "Жути бетон",
  "block.minecraft.yellow_concrete_powder": "Жути бетон у праху",
  "block.minecraft.yellow_glazed_terracotta": "Теракота са глазуром жуте",
  "block.minecraft.yellow_shulker_box": "Жута Шулкер кутија",
  "block.minecraft.yellow_stained_glass": "Жуто обојено стакло",
  "block.minecraft.yellow_stained_glass_pane": "Жута стаклена плоча",
  "block.minecraft.yellow_terracotta": "Жута теракота",
  "block.minecraft.yellow_wool": "Жута вуна",
  "block.minecraft.zombie_head": "Глава зомбија",
  "block.minecraft.zombie_wall_head": "Зидна глава зомбија",
  "item.minecraft.acacia_boat": "Чамац од багрема",
  "item.minecraft.acacia_chest_boat": "Чамац од багрема са ковчегом",
  "item.minecraft.allay_spawn_egg": "Јаје блаже",
  "item.minecraft.amethyst_shard": "Крхотина аметиста",
  "item.minecraft.angler_pottery_shard": "Делић грнчарије \"Пецарош\"",
  "item.minecraft.angler_pottery_sherd": "Делић грнчарије \"Пецарош\"",
  "item.minecraft.apple": "Јабука",
  "item.minecraft.archer_pottery_shard": "Делић грнчарије \"Стрелац\"",
  "item.minecraft.archer_pottery_sherd": "Делић грнчарије \"Стрелац\"",
  "item.minecraft.armadillo_scute": "Армадилов оклоп",
  "item.minecraft.armadillo_spawn_egg": "Јаје армадила",
  "item.minecraft.armor_stand": "Постоље за оклоп",
  "item.minecraft.arms_up_pottery_shard": "Делић грнчарије \"Руке у вис\"",
  "item.minecraft.arms_up_pottery_sherd": "Делић грнчарије \"Руке у вис\"",
  "item.minecraft.arrow": "Стрела",
  "item.minecraft.axolotl_bucket": "Кофа са аксолотлом",
  "item.minecraft.axolotl_spawn_egg": "Јаје аксолотла",
  "item.minecraft.baked_potato": "Испечен кромпир",
  "item.minecraft.bamboo_chest_raft": "Бамбусов сплав са ковчегом",
  "item.minecraft.bamboo_raft": "Бамбусов сплав",
  "item.minecraft.bat_spawn_egg": "Јаје слепог миша",
  "item.minecraft.bee_spawn_egg": "Јаје пчеле",
  "item.minecraft.beef": "Сирова говедина",
  "item.minecraft.beetroot": "Цвекла",
  "item.minecraft.beetroot_seeds": "Семе цвекле",
  "item.minecraft.beetroot_soup": "Супа од цвекле",
  "item.minecraft.birch_boat": "Брезов чамац",
  "item.minecraft.birch_chest_boat": "Брезов чамац са ковчегом",
  "item.minecraft.black_bundle": "Црни свежањ",
  "item.minecraft.black_dye": "Црна боја",
  "item.minecraft.black_harness": "Црна орма",
  "item.minecraft.blade_pottery_shard": "Делић грнчарије „Сечиво”",
  "item.minecraft.blade_pottery_sherd": "Делић грнчарије „Сечиво”",
  "item.minecraft.blaze_powder": "Огњени прах",
  "item.minecraft.blaze_rod": "Огњени штап",
  "item.minecraft.blaze_spawn_egg": "Јаје огњеног",
  "item.minecraft.blue_bundle": "Плави свежањ",
  "item.minecraft.blue_dye": "Плава боја",
  "item.minecraft.blue_egg": "Плаво јаје",
  "item.minecraft.blue_harness": "Плава орма",
  "item.minecraft.bogged_spawn_egg": "Јаје заглибљеног",
  "item.minecraft.bolt_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Изглед оклопа \"Шраф\"",
  "item.minecraft.bone": "Кост",
  "item.minecraft.bone_meal": "Коштано брашно",
  "item.minecraft.book": "Књига",
  "item.minecraft.bordure_indented_banner_pattern": "Шара барјака \"Ивица\"",
  "item.minecraft.bow": "Лук",
  "item.minecraft.bowl": "Чинија",
  "item.minecraft.bread": "Хлеб",
  "item.minecraft.breeze_rod": "Ветровити штап",
  "item.minecraft.breeze_spawn_egg": "Јаје Ветровитог",
  "item.minecraft.brewer_pottery_shard": "Делић грнчарије \"Напитак\"",
  "item.minecraft.brewer_pottery_sherd": "Делић грнчарије \"Напитак\"",
  "item.minecraft.brewing_stand": "Самовар за напитке",
  "item.minecraft.brick": "Цигла",
  "item.minecraft.brown_bundle": "Браон свежањ",
  "item.minecraft.brown_dye": "Браон боја",
  "item.minecraft.brown_egg": "Браон јаје",
  "item.minecraft.brown_harness": "Браон орма",
  "item.minecraft.brush": "Четкица",
  "item.minecraft.bucket": "Кофа",
  "item.minecraft.bundle": "Свежањ",
  "item.minecraft.bundle.empty": "Празан",
  "item.minecraft.bundle.empty.description": "Може држати помешане предмете",
  "item.minecraft.bundle.full": "Пун",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Делић грнчарије \"Пламен\"",
  "item.minecraft.burn_pottery_sherd": "Делић грнчарије \"Пламен\"",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Јаје камиле",
  "item.minecraft.carrot": "Шаргарепа",
  "item.minecraft.carrot_on_a_stick": "Шаргарепа на штапу",
  "item.minecraft.cat_spawn_egg": "Јаје мачке",
  "item.minecraft.cauldron": "Котао",
  "item.minecraft.cave_spider_spawn_egg": "Јаје пећинског паука",
  "item.minecraft.chainmail_boots": "Верижне чизме",
  "item.minecraft.chainmail_chestplate": "Верижњача",
  "item.minecraft.chainmail_helmet": "Верижна капуљача",
  "item.minecraft.chainmail_leggings": "Верижне ногавице",
  "item.minecraft.charcoal": "Дрвени угаљ",
  "item.minecraft.cherry_boat": "Трешњин чамац",
  "item.minecraft.cherry_chest_boat": "Трешњин чамац са ковчегом",
  "item.minecraft.chest_minecart": "Колица са ковчегом",
  "item.minecraft.chicken": "Сирова пилетина",
  "item.minecraft.chicken_spawn_egg": "Јаје кокошке",
  "item.minecraft.chorus_fruit": "Хорус воћка",
  "item.minecraft.clay_ball": "Глинена лопта",
  "item.minecraft.clock": "Сат",
  "item.minecraft.coal": "Угаљ",
  "item.minecraft.coast_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Изглед оклопа \"Обала\"",
  "item.minecraft.cocoa_beans": "Какао зрневље",
  "item.minecraft.cod": "Сиров бакалар",
  "item.minecraft.cod_bucket": "Кофа са бакаларом",
  "item.minecraft.cod_spawn_egg": "Јаје бакалара",
  "item.minecraft.command_block_minecart": "Колица са командним блоком",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Бифтек",
  "item.minecraft.cooked_chicken": "Печено пиле",
  "item.minecraft.cooked_cod": "Кувани бакалар",
  "item.minecraft.cooked_mutton": "Кувана јагњетина",
  "item.minecraft.cooked_porkchop": "Печена крменадла",
  "item.minecraft.cooked_rabbit": "Кувани зец",
  "item.minecraft.cooked_salmon": "Куван лосос",
  "item.minecraft.cookie": "Колачић",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Бакарна полуга",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Јаје краве",
  "item.minecraft.creaking_spawn_egg": "Јаје шкрипца",
  "item.minecraft.creeper_banner_pattern": "Шара барјака",
  "item.minecraft.creeper_banner_pattern.desc": "Симбол Крипера",
  "item.minecraft.creeper_banner_pattern.new": "Шара барјака \"Баук\"",
  "item.minecraft.creeper_spawn_egg": "Јаје крипера",
  "item.minecraft.crossbow": "Cамострел",
  "item.minecraft.crossbow.projectile": "Пројектил:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Тиркизни свежањ",
  "item.minecraft.cyan_dye": "Тиркизна боја",
  "item.minecraft.cyan_harness": "Тиркизна орма",
  "item.minecraft.danger_pottery_shard": "Делић грнчарије \"Опасност\"",
  "item.minecraft.danger_pottery_sherd": "Делић грнчарије \"Опасност\"",
  "item.minecraft.dark_oak_boat": "Тамни храстов чамац",
  "item.minecraft.dark_oak_chest_boat": "Тамни храстов чамац са ковчегом",
  "item.minecraft.debug_stick": "Штап за дебаговање",
  "item.minecraft.debug_stick.empty": "%s нема особина",
  "item.minecraft.debug_stick.select": "одабрано \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" на %s",
  "item.minecraft.diamond": "Дијамант",
  "item.minecraft.diamond_axe": "Дијамантска секира",
  "item.minecraft.diamond_boots": "Дијамантске чизме",
  "item.minecraft.diamond_chestplate": "Дијамантски нагрудник",
  "item.minecraft.diamond_helmet": "Дијамантски шлем",
  "item.minecraft.diamond_hoe": "Дијамантска мотика",
  "item.minecraft.diamond_horse_armor": "Дијамантски коњски оклоп",
  "item.minecraft.diamond_leggings": "Дијамантске панталоне",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Дијамантски крамп",
  "item.minecraft.diamond_shovel": "Дијамантска лопата",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Дијамантски мач",
  "item.minecraft.disc_fragment_5": "Комад плоче",
  "item.minecraft.disc_fragment_5.desc": "Музичка плоча - 5",
  "item.minecraft.dolphin_spawn_egg": "Јаје делфина",
  "item.minecraft.donkey_spawn_egg": "Јаје магарца",
  "item.minecraft.dragon_breath": "Змајев дах",
  "item.minecraft.dried_kelp": "Осушена морска алга",
  "item.minecraft.drowned_spawn_egg": "Јаје утопљеника",
  "item.minecraft.dune_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Изглед оклопа \"Дина\"",
  "item.minecraft.echo_shard": "Крхотина еха",
  "item.minecraft.egg": "Jaje",
  "item.minecraft.elder_guardian_spawn_egg": "Јаје старог чувара",
  "item.minecraft.elytra": "Крила",
  "item.minecraft.emerald": "Смарагд",
  "item.minecraft.enchanted_book": "Зачарана књига",
  "item.minecraft.enchanted_golden_apple": "Зачарана златна јабука",
  "item.minecraft.end_crystal": "Енд кристал",
  "item.minecraft.ender_dragon_spawn_egg": "Јаје Ендер змаја",
  "item.minecraft.ender_eye": "Око Ендера",
  "item.minecraft.ender_pearl": "Ендер бисер",
  "item.minecraft.enderman_spawn_egg": "Ендермен јаје",
  "item.minecraft.endermite_spawn_egg": "Ендермит јаје",
  "item.minecraft.evoker_spawn_egg": "Јаје призиватеља",
  "item.minecraft.experience_bottle": "Чаробна боца",
  "item.minecraft.explorer_pottery_shard": "Делић грнчарије \"Истраживач\"",
  "item.minecraft.explorer_pottery_sherd": "Делић грнчарије \"Истраживач\"",
  "item.minecraft.eye_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Изглед оклопа \"Око\"",
  "item.minecraft.feather": "Перо",
  "item.minecraft.fermented_spider_eye": "Ферментисано пауково око",
  "item.minecraft.field_masoned_banner_pattern": "Шара барјака \"Зид\"",
  "item.minecraft.filled_map": "Мапа",
  "item.minecraft.fire_charge": "Ватрена лопта",
  "item.minecraft.firework_rocket": "Ватрометска ракета",
  "item.minecraft.firework_rocket.flight": "Лет траје:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Ватрометска звезда",
  "item.minecraft.firework_star.black": "Црн",
  "item.minecraft.firework_star.blue": "Плав",
  "item.minecraft.firework_star.brown": "Браон",
  "item.minecraft.firework_star.custom_color": "По жељи",
  "item.minecraft.firework_star.cyan": "Тиркизна",
  "item.minecraft.firework_star.fade_to": "Претопи у",
  "item.minecraft.firework_star.flicker": "Светлуцање",
  "item.minecraft.firework_star.gray": "Сив",
  "item.minecraft.firework_star.green": "Зелен",
  "item.minecraft.firework_star.light_blue": "Светлоплава",
  "item.minecraft.firework_star.light_gray": "Светлосива",
  "item.minecraft.firework_star.lime": "Светлозелена",
  "item.minecraft.firework_star.magenta": "Магента",
  "item.minecraft.firework_star.orange": "Наранџаст",
  "item.minecraft.firework_star.pink": "Розе",
  "item.minecraft.firework_star.purple": "Љубичаста",
  "item.minecraft.firework_star.red": "Црвен",
  "item.minecraft.firework_star.shape": "Непознати облик",
  "item.minecraft.firework_star.shape.burst": "Прасак",
  "item.minecraft.firework_star.shape.creeper": "Облика крипера",
  "item.minecraft.firework_star.shape.large_ball": "Велика лопта",
  "item.minecraft.firework_star.shape.small_ball": "Мала лопта",
  "item.minecraft.firework_star.shape.star": "Облик звезде",
  "item.minecraft.firework_star.trail": "Траг",
  "item.minecraft.firework_star.white": "Бео",
  "item.minecraft.firework_star.yellow": "Жут",
  "item.minecraft.fishing_rod": "Штап за пецање",
  "item.minecraft.flint": "Кремен",
  "item.minecraft.flint_and_steel": "Кремен и челик",
  "item.minecraft.flow_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Изглед оклопа \"Ток\"",
  "item.minecraft.flow_banner_pattern": "Шара барјака",
  "item.minecraft.flow_banner_pattern.desc": "Ток",
  "item.minecraft.flow_banner_pattern.new": "Шара барјака \"Ток\"",
  "item.minecraft.flow_pottery_sherd": "Делић грнчарије \"Ток\"",
  "item.minecraft.flower_banner_pattern": "Шара барјака",
  "item.minecraft.flower_banner_pattern.desc": "Лик цвета",
  "item.minecraft.flower_banner_pattern.new": "Шара барјака \"Цвет\"",
  "item.minecraft.flower_pot": "Саксија",
  "item.minecraft.fox_spawn_egg": "Јаје лисице",
  "item.minecraft.friend_pottery_shard": "Делић грнчарије „Пријатељ”",
  "item.minecraft.friend_pottery_sherd": "Делић грнчарије „Пријатељ”",
  "item.minecraft.frog_spawn_egg": "Јаје жабе",
  "item.minecraft.furnace_minecart": "Колица са пећницом",
  "item.minecraft.ghast_spawn_egg": "Јаје гаста",
  "item.minecraft.ghast_tear": "Гаст суза",
  "item.minecraft.glass_bottle": "Стаклена боца",
  "item.minecraft.glistering_melon_slice": "Светлуцава кришка лубенице",
  "item.minecraft.globe_banner_pattern": "Шара барјака",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "Шара барјака \"Глобус\"",
  "item.minecraft.glow_berries": "Светлеће бобице",
  "item.minecraft.glow_ink_sac": "Светлећа врећица са мастилом",
  "item.minecraft.glow_item_frame": "Светлећи рам за предмете",
  "item.minecraft.glow_squid_spawn_egg": "Јаје светлеће лигње",
  "item.minecraft.glowstone_dust": "Прах жаркамена",
  "item.minecraft.goat_horn": "Козји рог",
  "item.minecraft.goat_spawn_egg": "Јаје козе",
  "item.minecraft.gold_ingot": "Златна полуга",
  "item.minecraft.gold_nugget": "Грумен злата",
  "item.minecraft.golden_apple": "Златна јабука",
  "item.minecraft.golden_axe": "Златна секира",
  "item.minecraft.golden_boots": "Златне чизме",
  "item.minecraft.golden_carrot": "Златна шаргарепа",
  "item.minecraft.golden_chestplate": "Златни нагрудник",
  "item.minecraft.golden_helmet": "Златни шлем",
  "item.minecraft.golden_hoe": "Златна мотика",
  "item.minecraft.golden_horse_armor": "Златни коњски оклоп",
  "item.minecraft.golden_leggings": "Златне панталоне",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Златни крамп",
  "item.minecraft.golden_shovel": "Златна лопата",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Златни мач",
  "item.minecraft.gray_bundle": "Сиви свежањ",
  "item.minecraft.gray_dye": "Сива боја",
  "item.minecraft.gray_harness": "Сива орма",
  "item.minecraft.green_bundle": "Зелени свежањ",
  "item.minecraft.green_dye": "Зелена боја",
  "item.minecraft.green_harness": "Зелена орма",
  "item.minecraft.guardian_spawn_egg": "Јаје чувара",
  "item.minecraft.gunpowder": "Барут",
  "item.minecraft.guster_banner_pattern": "Шара барјака",
  "item.minecraft.guster_banner_pattern.desc": "Кошава",
  "item.minecraft.guster_banner_pattern.new": "Шара барјака \"Циклон\"",
  "item.minecraft.guster_pottery_sherd": "Делић грнчарије \"Кошава\"",
  "item.minecraft.happy_ghast_spawn_egg": "Јаје срећног гаста",
  "item.minecraft.harness": "Орма",
  "item.minecraft.heart_of_the_sea": "Срце мора",
  "item.minecraft.heart_pottery_shard": "Делић грнчарије \"Срце\"",
  "item.minecraft.heart_pottery_sherd": "Делић грнчарије \"Срце\"",
  "item.minecraft.heartbreak_pottery_shard": "Делић грнчарије „Сломљено срце”",
  "item.minecraft.heartbreak_pottery_sherd": "Делић грнчарије „Сломљено срце”",
  "item.minecraft.hoglin_spawn_egg": "Јаје хоглина",
  "item.minecraft.honey_bottle": "Боца меда",
  "item.minecraft.honeycomb": "Саће",
  "item.minecraft.hopper_minecart": "Колица са левком",
  "item.minecraft.horse_spawn_egg": "Јаје коња",
  "item.minecraft.host_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.host_armor_trim_smithing_template.new": "Изглед оклопа \"Домаћин\"",
  "item.minecraft.howl_pottery_shard": "Делић грнчарије \"Завијање\"",
  "item.minecraft.howl_pottery_sherd": "Делић грнчарије \"Завијање\"",
  "item.minecraft.husk_spawn_egg": "Јаје љуске",
  "item.minecraft.ink_sac": "Врећица са мастилом",
  "item.minecraft.iron_axe": "Гвоздена секира",
  "item.minecraft.iron_boots": "Гвоздене чизме",
  "item.minecraft.iron_chestplate": "Гвоздени нагрудник",
  "item.minecraft.iron_golem_spawn_egg": "Јаје гвозденог голема",
  "item.minecraft.iron_helmet": "Гвоздени шлем",
  "item.minecraft.iron_hoe": "Гвоздена мотика",
  "item.minecraft.iron_horse_armor": "Гвоздени коњски оклоп",
  "item.minecraft.iron_ingot": "Гвоздена полуга",
  "item.minecraft.iron_leggings": "Гвоздене панталоне",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Грумен гвожђа",
  "item.minecraft.iron_pickaxe": "Гвоздени крамп",
  "item.minecraft.iron_shovel": "Гвоздена лопата",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Гвоздени мач",
  "item.minecraft.item_frame": "Рам за предмет",
  "item.minecraft.jungle_boat": "Чамац од дрвета џунгле",
  "item.minecraft.jungle_chest_boat": "Чамац од дрвета џунгле са ковчегом",
  "item.minecraft.knowledge_book": "Књига знања",
  "item.minecraft.lapis_lazuli": "Лапис лазули",
  "item.minecraft.lava_bucket": "Кофа са лавом",
  "item.minecraft.lead": "Поводац",
  "item.minecraft.leather": "Кожа",
  "item.minecraft.leather_boots": "Кожне чизме",
  "item.minecraft.leather_chestplate": "Кожни прслук",
  "item.minecraft.leather_helmet": "Кожна капа",
  "item.minecraft.leather_horse_armor": "Кожни коњски оклоп",
  "item.minecraft.leather_leggings": "Кожне панталоне",
  "item.minecraft.light_blue_bundle": "Светлоплави свежањ",
  "item.minecraft.light_blue_dye": "Светлоплава боја",
  "item.minecraft.light_blue_harness": "Светлоплава орма",
  "item.minecraft.light_gray_bundle": "Светлосиви свежањ",
  "item.minecraft.light_gray_dye": "Светлосива боја",
  "item.minecraft.light_gray_harness": "Светлосива орма",
  "item.minecraft.lime_bundle": "Светлозелени свежањ",
  "item.minecraft.lime_dye": "Светлозелена боја",
  "item.minecraft.lime_harness": "Светлозелена орма",
  "item.minecraft.lingering_potion": "Дугортајни напитак",
  "item.minecraft.lingering_potion.effect.awkward": "Неугодни дуготрајни напитак",
  "item.minecraft.lingering_potion.effect.empty": "Дуготрајни ненаправљив напитак",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Дуготрајни напитак отпорности на воду",
  "item.minecraft.lingering_potion.effect.harming": "Дуготрајни напитак повређивања",
  "item.minecraft.lingering_potion.effect.healing": "Дуготрајни напитак лечења",
  "item.minecraft.lingering_potion.effect.infested": "Дуготрајни напитак инфестације",
  "item.minecraft.lingering_potion.effect.invisibility": "Дуготрајни напитак невидљивости",
  "item.minecraft.lingering_potion.effect.leaping": "Дуготрајни напитак скакања",
  "item.minecraft.lingering_potion.effect.levitation": "Дуготрајни напитак левитације",
  "item.minecraft.lingering_potion.effect.luck": "Дуготрајни напитак среће",
  "item.minecraft.lingering_potion.effect.mundane": "Обични дуготрајни напитак",
  "item.minecraft.lingering_potion.effect.night_vision": "Дуготрајни напитак ноћног вида",
  "item.minecraft.lingering_potion.effect.oozing": "Дуготрајни напитак излучивања",
  "item.minecraft.lingering_potion.effect.poison": "Дуготрајни напитак тровања",
  "item.minecraft.lingering_potion.effect.regeneration": "Дуготрајни напитак регенерације",
  "item.minecraft.lingering_potion.effect.slow_falling": "Дуготрајни напитак спорог падања",
  "item.minecraft.lingering_potion.effect.slowness": "Дуготрајни напитак спорости",
  "item.minecraft.lingering_potion.effect.strength": "Дуготрајни напитак снаге",
  "item.minecraft.lingering_potion.effect.swiftness": "Дуготрајни напитак брзине",
  "item.minecraft.lingering_potion.effect.thick": "Густи дуготрајни напитак",
  "item.minecraft.lingering_potion.effect.turtle_master": "Дуготрајни напитак господара корњаче",
  "item.minecraft.lingering_potion.effect.water": "Дуготрајна водена боца",
  "item.minecraft.lingering_potion.effect.water_breathing": "Дуготрајни напитак дисања под водом",
  "item.minecraft.lingering_potion.effect.weakness": "Дуготрајни напитак слабости",
  "item.minecraft.lingering_potion.effect.weaving": "Дуготрајни напитак плетења",
  "item.minecraft.lingering_potion.effect.wind_charged": "Дуготрајни напитак снаге ваздуха",
  "item.minecraft.llama_spawn_egg": "Јаје ламе",
  "item.minecraft.lodestone_compass": "Компас за магнетит",
  "item.minecraft.mace": "Буздован",
  "item.minecraft.magenta_bundle": "Магента свежањ",
  "item.minecraft.magenta_dye": "Магента боја",
  "item.minecraft.magenta_harness": "Магента орма",
  "item.minecraft.magma_cream": "Магма крем",
  "item.minecraft.magma_cube_spawn_egg": "Јаје коцке магме",
  "item.minecraft.mangrove_boat": "Чамац од мангрова",
  "item.minecraft.mangrove_chest_boat": "Чамац од мангрова са ковчегом",
  "item.minecraft.map": "Празна мапа",
  "item.minecraft.melon_seeds": "Семе лубенице",
  "item.minecraft.melon_slice": "Кришка лубенице",
  "item.minecraft.milk_bucket": "Кофа млека",
  "item.minecraft.minecart": "Рударска колица",
  "item.minecraft.miner_pottery_shard": "Делић грнчарије \"Рудар\"",
  "item.minecraft.miner_pottery_sherd": "Делић грнчарије \"Рудар\"",
  "item.minecraft.mojang_banner_pattern": "Шара барјака",
  "item.minecraft.mojang_banner_pattern.desc": "Ствар",
  "item.minecraft.mojang_banner_pattern.new": "Шара барјака \"Ствар\"",
  "item.minecraft.mooshroom_spawn_egg": "Мушрум јаје",
  "item.minecraft.mourner_pottery_shard": "Делић грнчарије \"Жал\"",
  "item.minecraft.mourner_pottery_sherd": "Делић грнчарије \"Жал\"",
  "item.minecraft.mule_spawn_egg": "Јаје мазге",
  "item.minecraft.mushroom_stew": "Паприкаш од печурака",
  "item.minecraft.music_disc_11": "Музичка плоча",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Музичка плоча",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Музичка плоча",
  "item.minecraft.music_disc_5.desc": "Самуел Оберг - 5",
  "item.minecraft.music_disc_blocks": "Музичка плоча",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Музичка плоча",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Музичка плоча",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Музичка плоча",
  "item.minecraft.music_disc_creator.desc": "Лена Рејн - Creator",
  "item.minecraft.music_disc_creator_music_box": "Музичка плоча",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рејн - Creator (Музичка кутија)",
  "item.minecraft.music_disc_far": "Музичка плоча",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muzički disk",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Музичка плоча",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Музичка плоча",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Музичка плоча",
  "item.minecraft.music_disc_otherside.desc": "Лена Рејн - otherside",
  "item.minecraft.music_disc_pigstep": "Музичка плоча",
  "item.minecraft.music_disc_pigstep.desc": "Лена Рејн - Pigstep",
  "item.minecraft.music_disc_precipice": "Музичка плоча",
  "item.minecraft.music_disc_precipice.desc": "Aрон Шероф - Precipice",
  "item.minecraft.music_disc_relic": "Музичка плоча",
  "item.minecraft.music_disc_relic.desc": "Aрон Шероф - Relic",
  "item.minecraft.music_disc_stal": "Музичка плоча",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Музичка плоча",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muzički disk",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Музичка плоча",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Музичка плоча",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Сирова јагњетина",
  "item.minecraft.name_tag": "Етикета",
  "item.minecraft.nautilus_shell": "Наутилус шкољка",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Недер цигла",
  "item.minecraft.nether_star": "Недер звезда",
  "item.minecraft.nether_wart": "Недер лишај",
  "item.minecraft.netherite_axe": "Недеритска секира",
  "item.minecraft.netherite_boots": "Недеритске чизме",
  "item.minecraft.netherite_chestplate": "Недеритски нагрудник",
  "item.minecraft.netherite_helmet": "Недеритска кацига",
  "item.minecraft.netherite_hoe": "Недеритска мотика",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Недерит полуга",
  "item.minecraft.netherite_leggings": "Недеритске панталоне",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Недеритски крамп",
  "item.minecraft.netherite_scrap": "Одломак недерита",
  "item.minecraft.netherite_shovel": "Недеритска лопата",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Недеритски мач",
  "item.minecraft.netherite_upgrade_smithing_template": "Ковачки шаблон",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Недерит надоградња",
  "item.minecraft.oak_boat": "Храстов чамац",
  "item.minecraft.oak_chest_boat": "Храстов чамац са ковчегом",
  "item.minecraft.ocelot_spawn_egg": "Јаје дивље мачке",
  "item.minecraft.ominous_bottle": "Злослутна боца",
  "item.minecraft.ominous_trial_key": "Злослутни кључ Изазова",
  "item.minecraft.orange_bundle": "Наранџасти свежањ",
  "item.minecraft.orange_dye": "Наранџаста боја",
  "item.minecraft.orange_harness": "Наранџаста орма",
  "item.minecraft.painting": "Слика",
  "item.minecraft.pale_oak_boat": "Бледи храстов чамац",
  "item.minecraft.pale_oak_chest_boat": "Бледи храстов чамац са ковчегом",
  "item.minecraft.panda_spawn_egg": "Јаје панде",
  "item.minecraft.paper": "Папир",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Јаје папагаја",
  "item.minecraft.phantom_membrane": "Фантом мембрана",
  "item.minecraft.phantom_spawn_egg": "Јаје фантома",
  "item.minecraft.pig_spawn_egg": "Јаје свиње",
  "item.minecraft.piglin_banner_pattern": "Шара барјака",
  "item.minecraft.piglin_banner_pattern.desc": "Њушка",
  "item.minecraft.piglin_banner_pattern.new": "Шара барјака \"Њушка\"",
  "item.minecraft.piglin_brute_spawn_egg": "Јаје суровог пиглина",
  "item.minecraft.piglin_spawn_egg": "Јаје пиглина",
  "item.minecraft.pillager_spawn_egg": "Јаје разбојника",
  "item.minecraft.pink_bundle": "Розе свежањ",
  "item.minecraft.pink_dye": "Розе боја",
  "item.minecraft.pink_harness": "Роза орма",
  "item.minecraft.pitcher_plant": "Биљка врч",
  "item.minecraft.pitcher_pod": "Чаура врча",
  "item.minecraft.plenty_pottery_shard": "Делић грнчарије \"Прегршт\"",
  "item.minecraft.plenty_pottery_sherd": "Делић грнчарије \"Прегршт\"",
  "item.minecraft.poisonous_potato": "Отровни кромпир",
  "item.minecraft.polar_bear_spawn_egg": "Јаје поларног медведа",
  "item.minecraft.popped_chorus_fruit": "Напукло хорус воће",
  "item.minecraft.porkchop": "Сирова крменадла",
  "item.minecraft.potato": "Кромпир",
  "item.minecraft.potion": "Напитак",
  "item.minecraft.potion.effect.awkward": "Чудни напитак",
  "item.minecraft.potion.effect.empty": "Ненаправљив напитак",
  "item.minecraft.potion.effect.fire_resistance": "Напитак отпорности на ватру",
  "item.minecraft.potion.effect.harming": "Напитак повређивања",
  "item.minecraft.potion.effect.healing": "Напитак лечења",
  "item.minecraft.potion.effect.infested": "Напитак инфестације",
  "item.minecraft.potion.effect.invisibility": "Напитак невидљивости",
  "item.minecraft.potion.effect.leaping": "Напитак скакања",
  "item.minecraft.potion.effect.levitation": "Напитак левитације",
  "item.minecraft.potion.effect.luck": "Напитак среће",
  "item.minecraft.potion.effect.mundane": "Обични напитак",
  "item.minecraft.potion.effect.night_vision": "Напитак ноћног вида",
  "item.minecraft.potion.effect.oozing": "Напитак излучивања",
  "item.minecraft.potion.effect.poison": "Напитак тровања",
  "item.minecraft.potion.effect.regeneration": "Напитак регенерације",
  "item.minecraft.potion.effect.slow_falling": "Напитак спорог падања",
  "item.minecraft.potion.effect.slowness": "Напитак спорости",
  "item.minecraft.potion.effect.strength": "Напитак снаге",
  "item.minecraft.potion.effect.swiftness": "Напитак брзине",
  "item.minecraft.potion.effect.thick": "Густи напитак",
  "item.minecraft.potion.effect.turtle_master": "Напитак господара корњаче",
  "item.minecraft.potion.effect.water": "Боца са водом",
  "item.minecraft.potion.effect.water_breathing": "Напитак дисања под водом",
  "item.minecraft.potion.effect.weakness": "Напитак слабости",
  "item.minecraft.potion.effect.weaving": "Напитак плетења",
  "item.minecraft.potion.effect.wind_charged": "Напитак снаге ваздуха",
  "item.minecraft.pottery_shard_archer": "Делић грнчарије \"Стрелац\"",
  "item.minecraft.pottery_shard_arms_up": "Делић грнчарије „Руке у вис”",
  "item.minecraft.pottery_shard_prize": "Делић грнчарије „Награда”",
  "item.minecraft.pottery_shard_skull": "Делић грнчарије „Лобања”",
  "item.minecraft.powder_snow_bucket": "Кофа са снегом у праху",
  "item.minecraft.prismarine_crystals": "Кристали призмарина",
  "item.minecraft.prismarine_shard": "Крхотина призмарина",
  "item.minecraft.prize_pottery_shard": "Делић грнчарије „Награда”",
  "item.minecraft.prize_pottery_sherd": "Делић грнчарије „Награда”",
  "item.minecraft.pufferfish": "Фугу риба",
  "item.minecraft.pufferfish_bucket": "Кофа Фугу рибе",
  "item.minecraft.pufferfish_spawn_egg": "Јаје фугу рибе",
  "item.minecraft.pumpkin_pie": "Пита од бундеве",
  "item.minecraft.pumpkin_seeds": "Семе бундеве",
  "item.minecraft.purple_bundle": "Љубичасти свежањ",
  "item.minecraft.purple_dye": "Љубичаста боја",
  "item.minecraft.purple_harness": "Љубичаста орма",
  "item.minecraft.quartz": "Недер кварц",
  "item.minecraft.rabbit": "Сиров зец",
  "item.minecraft.rabbit_foot": "Зечија шапа",
  "item.minecraft.rabbit_hide": "Зечије крзно",
  "item.minecraft.rabbit_spawn_egg": "Јаје зеца",
  "item.minecraft.rabbit_stew": "Зечији паприкаш",
  "item.minecraft.raiser_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Јаје разарача",
  "item.minecraft.raw_copper": "Сирови бакар",
  "item.minecraft.raw_gold": "Сирово злато",
  "item.minecraft.raw_iron": "Сирово гвожђе",
  "item.minecraft.recovery_compass": "Повратни компас",
  "item.minecraft.red_bundle": "Црвени свежањ",
  "item.minecraft.red_dye": "Црвена боја",
  "item.minecraft.red_harness": "Црвена орма",
  "item.minecraft.redstone": "Редстоун прах",
  "item.minecraft.resin_brick": "Смолена цигла",
  "item.minecraft.resin_clump": "Грудвица смоле",
  "item.minecraft.rib_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Труло месо",
  "item.minecraft.saddle": "Седло",
  "item.minecraft.salmon": "Сирови лосос",
  "item.minecraft.salmon_bucket": "Кофа са лососом",
  "item.minecraft.salmon_spawn_egg": "Јаје лососа",
  "item.minecraft.scrape_pottery_sherd": "Делић грнчарије \"Стругање\"",
  "item.minecraft.scute": "Оклоп",
  "item.minecraft.sentry_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Делић грнчарије \"Сноп\"",
  "item.minecraft.sheaf_pottery_sherd": "Делић грнчарије \"Сноп\"",
  "item.minecraft.shears": "Маказе",
  "item.minecraft.sheep_spawn_egg": "Јаје овце",
  "item.minecraft.shelter_pottery_shard": "Делић грнчарије \"Склониште\"",
  "item.minecraft.shelter_pottery_sherd": "Делић грнчарије \"Склониште\"",
  "item.minecraft.shield": "Штит",
  "item.minecraft.shield.black": "Црни штит",
  "item.minecraft.shield.blue": "Плави штит",
  "item.minecraft.shield.brown": "Браон штит",
  "item.minecraft.shield.cyan": "Цијан штит",
  "item.minecraft.shield.gray": "Сиви штит",
  "item.minecraft.shield.green": "Зелени штит",
  "item.minecraft.shield.light_blue": "Светлоплави штит",
  "item.minecraft.shield.light_gray": "Светлосив штит",
  "item.minecraft.shield.lime": "Светлозелени штит",
  "item.minecraft.shield.magenta": "Магента штит",
  "item.minecraft.shield.orange": "Наранџасти штит",
  "item.minecraft.shield.pink": "Розе штит",
  "item.minecraft.shield.purple": "Љубичасти штит",
  "item.minecraft.shield.red": "Црвени штит",
  "item.minecraft.shield.white": "Бели Штит",
  "item.minecraft.shield.yellow": "Жути штит",
  "item.minecraft.shulker_shell": "Шулкер љуска",
  "item.minecraft.shulker_spawn_egg": "Јаје шулкера",
  "item.minecraft.sign": "Знак",
  "item.minecraft.silence_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Јаје сребрне рибе",
  "item.minecraft.skeleton_horse_spawn_egg": "Јаје костура коња",
  "item.minecraft.skeleton_spawn_egg": "Јаје костура",
  "item.minecraft.skull_banner_pattern": "Шара барјака",
  "item.minecraft.skull_banner_pattern.desc": "Лик лобање",
  "item.minecraft.skull_banner_pattern.new": "Шара барјака \"Лобања\"",
  "item.minecraft.skull_pottery_shard": "Делић грнчарије \"Лобања\"",
  "item.minecraft.skull_pottery_sherd": "Делић грнчарије \"Лобања\"",
  "item.minecraft.slime_ball": "Лопта од слузи",
  "item.minecraft.slime_spawn_egg": "Јаје слузи",
  "item.minecraft.smithing_template": "Ковачки шаблон",
  "item.minecraft.smithing_template.applies_to": "Примјењује се на:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Додајте полугу или кристал",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Оклоп",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Додајте део оклопа",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Полуге и кристали",
  "item.minecraft.smithing_template.ingredients": "Састојци:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Додај недерит полугу",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Дијамантска опрема",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Додај дијамантски оклоп, оружије или алат",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Недерит полуга",
  "item.minecraft.smithing_template.upgrade": "Надоградње: ",
  "item.minecraft.sniffer_spawn_egg": "Јаје њушкала",
  "item.minecraft.snort_pottery_shard": "Делић грнчарије \"Њушка\"",
  "item.minecraft.snort_pottery_sherd": "Делић грнчарије \"Њушка\"",
  "item.minecraft.snout_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Јаје снежног голема",
  "item.minecraft.snowball": "Грудва",
  "item.minecraft.spectral_arrow": "Спектрална стрела",
  "item.minecraft.spider_eye": "Пауково око",
  "item.minecraft.spider_spawn_egg": "Јаје паука",
  "item.minecraft.spire_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Распрскујући напитак",
  "item.minecraft.splash_potion.effect.awkward": "Неугодни распрскујући напитак",
  "item.minecraft.splash_potion.effect.empty": "Распрскујући ненаправљиви напитак",
  "item.minecraft.splash_potion.effect.fire_resistance": "Распрскујући напитак отпорности на ватру",
  "item.minecraft.splash_potion.effect.harming": "Распрскујући напитак повређивања",
  "item.minecraft.splash_potion.effect.healing": "Распрскујући напитак лечења",
  "item.minecraft.splash_potion.effect.infested": "Бачени напитак инфестације",
  "item.minecraft.splash_potion.effect.invisibility": "Распрскујући напитак невидљивости",
  "item.minecraft.splash_potion.effect.leaping": "Распрскујући напитак скакања",
  "item.minecraft.splash_potion.effect.levitation": "Распрскујући напитак левитације",
  "item.minecraft.splash_potion.effect.luck": "Распрскујући напитак среће",
  "item.minecraft.splash_potion.effect.mundane": "Обични распрскујући напитак",
  "item.minecraft.splash_potion.effect.night_vision": "Распрскујући напитак ноћног вида",
  "item.minecraft.splash_potion.effect.oozing": "Распрскујући напитак излучивања",
  "item.minecraft.splash_potion.effect.poison": "Распрскујући напитак тровања",
  "item.minecraft.splash_potion.effect.regeneration": "Распрскујући напитак отрова",
  "item.minecraft.splash_potion.effect.slow_falling": "Распрскујући напитак спорог падања",
  "item.minecraft.splash_potion.effect.slowness": "Распрскујући напитак спорости",
  "item.minecraft.splash_potion.effect.strength": "Распрскујући напитак снаге",
  "item.minecraft.splash_potion.effect.swiftness": "Распрскујући напитак брзине",
  "item.minecraft.splash_potion.effect.thick": "Густи распрскујући напитак",
  "item.minecraft.splash_potion.effect.turtle_master": "Офанзивни напитак господара корњаче",
  "item.minecraft.splash_potion.effect.water": "Распрскујућа водена боца",
  "item.minecraft.splash_potion.effect.water_breathing": "Распрскујући напитак дисања под водом",
  "item.minecraft.splash_potion.effect.weakness": "Распрскујући напитак слабости",
  "item.minecraft.splash_potion.effect.weaving": "Бачени напитак плетења",
  "item.minecraft.splash_potion.effect.wind_charged": "Распрскујући напитак снаге ваздуха",
  "item.minecraft.spruce_boat": "Чамац од смреке",
  "item.minecraft.spruce_chest_boat": "Чамац од смреке са ковчегом",
  "item.minecraft.spyglass": "Дурбин",
  "item.minecraft.squid_spawn_egg": "Јаје лигње",
  "item.minecraft.stick": "Штап",
  "item.minecraft.stone_axe": "Камена секира",
  "item.minecraft.stone_hoe": "Камена мотика",
  "item.minecraft.stone_pickaxe": "Камени крамп",
  "item.minecraft.stone_shovel": "Камена лопата",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Камени мач",
  "item.minecraft.stray_spawn_egg": "Јаје луталице",
  "item.minecraft.strider_spawn_egg": "Јаје шетача",
  "item.minecraft.string": "Нит",
  "item.minecraft.sugar": "Шећер",
  "item.minecraft.suspicious_stew": "Сумњиви паприкаш",
  "item.minecraft.sweet_berries": "Слатке бобице",
  "item.minecraft.tadpole_bucket": "Кофа са пуноглавцем",
  "item.minecraft.tadpole_spawn_egg": "Јаје пуноглавца",
  "item.minecraft.tide_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Изглед оклопа \"Плима\"",
  "item.minecraft.tipped_arrow": "Умочена стрела",
  "item.minecraft.tipped_arrow.effect.awkward": "Умочена стрела",
  "item.minecraft.tipped_arrow.effect.empty": "Неправљена умочена стрела",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стрела отпорности на ватру",
  "item.minecraft.tipped_arrow.effect.harming": "Стрела повређивања",
  "item.minecraft.tipped_arrow.effect.healing": "Стрела опорављања",
  "item.minecraft.tipped_arrow.effect.infested": "Стрела инфестације",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стрела невидљивости",
  "item.minecraft.tipped_arrow.effect.leaping": "Стрела скакања",
  "item.minecraft.tipped_arrow.effect.levitation": "Стрела левитације",
  "item.minecraft.tipped_arrow.effect.luck": "Стрела среће",
  "item.minecraft.tipped_arrow.effect.mundane": "Умочена стрела",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стрела ноћног вида",
  "item.minecraft.tipped_arrow.effect.oozing": "Стрела излучивања",
  "item.minecraft.tipped_arrow.effect.poison": "Стрела отрова",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стрела регенерације",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стрела спорог падања",
  "item.minecraft.tipped_arrow.effect.slowness": "Стрела спорости",
  "item.minecraft.tipped_arrow.effect.strength": "Стрела снаге",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стрела брзине",
  "item.minecraft.tipped_arrow.effect.thick": "Умочена стрела",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стрела господара корњаче",
  "item.minecraft.tipped_arrow.effect.water": "Стрела распрскивања",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стрела дисања под водом",
  "item.minecraft.tipped_arrow.effect.weakness": "Стрела слабости",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стрела снаге ваздуха",
  "item.minecraft.tnt_minecart": "Колица са динамитом",
  "item.minecraft.torchflower_seeds": "Семе бакљоцвета",
  "item.minecraft.totem_of_undying": "Тотем бесмрти",
  "item.minecraft.trader_llama_spawn_egg": "Jaje трговачке ламе",
  "item.minecraft.trial_key": "Кључ Изазова",
  "item.minecraft.trident": "Трозубац",
  "item.minecraft.tropical_fish": "Тропска риба",
  "item.minecraft.tropical_fish_bucket": "Кофа са тропском рибом",
  "item.minecraft.tropical_fish_spawn_egg": "Јаје тропске рибе",
  "item.minecraft.turtle_helmet": "Корњачин оклоп",
  "item.minecraft.turtle_scute": "Корњачин оклоп",
  "item.minecraft.turtle_spawn_egg": "Јаје корњаче",
  "item.minecraft.vex_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Јаје напасти",
  "item.minecraft.villager_spawn_egg": "Јаје сељака",
  "item.minecraft.vindicator_spawn_egg": "Јаје осветника",
  "item.minecraft.wandering_trader_spawn_egg": "Јаје лутајућег трговца",
  "item.minecraft.ward_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Јаје стражара",
  "item.minecraft.warped_fungus_on_a_stick": "Изопачена гљива на штапу",
  "item.minecraft.water_bucket": "Кофа са водом",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Изглед оклопа \"Путоказ\"",
  "item.minecraft.wheat": "Пшеница",
  "item.minecraft.wheat_seeds": "Семе пшенице",
  "item.minecraft.white_bundle": "Бели свежањ",
  "item.minecraft.white_dye": "Бела боја",
  "item.minecraft.white_harness": "Бела орма",
  "item.minecraft.wild_armor_trim_smithing_template": "Ковачки шаблон",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Изглед оклопа \"Дивљина\"",
  "item.minecraft.wind_charge": "Ваздушна лопта",
  "item.minecraft.witch_spawn_egg": "Јаје вештице",
  "item.minecraft.wither_skeleton_spawn_egg": "Јаје Видер костура",
  "item.minecraft.wither_spawn_egg": "Видерово јаје",
  "item.minecraft.wolf_armor": "Вучји оклоп",
  "item.minecraft.wolf_spawn_egg": "Јаје вука",
  "item.minecraft.wooden_axe": "Дрвена секира",
  "item.minecraft.wooden_hoe": "Дрвена мотика",
  "item.minecraft.wooden_pickaxe": "Дрвени крамп",
  "item.minecraft.wooden_shovel": "Дрвена лопата",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Дрвени мач",
  "item.minecraft.writable_book": "Књига и перо",
  "item.minecraft.written_book": "Написана књига",
  "item.minecraft.yellow_bundle": "Жути свежањ",
  "item.minecraft.yellow_dye": "Жута боја",
  "item.minecraft.yellow_harness": "Жута орма",
  "item.minecraft.zoglin_spawn_egg": "Јаје зоглина",
  "item.minecraft.zombie_horse_spawn_egg": "Јаје зомби коња",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Јаје зомбија",
  "item.minecraft.zombie_villager_spawn_egg": "Јаје зомби сељака",
  "item.minecraft.zombified_piglin_spawn_egg": "Јаје зомбификованог пиглина"
}
export const sr_sp = items; 
